export const translations = {
    en: {
        signUp: "Sign Up",
        signIn: "Sign In",
        home: "Home",
        services: "Services",
        contact: "Contact",
        shorts: "Shorts",
        viewMore: "View More on YouTube",
        downloadApp: "Download App",
        urdu: "اردو",
        english: "English",
        searchPlaceholder: "Search...",
        usedCars: "Used Cars",
        newCars: "New Cars",
        bikes: "Bikes",
        autoStore: "Auto Store",
        blog: "Blog",
        more: "More",
        postAd: "Post an Ad",
        findUsedCars: "Find Used Cars for Sale",
        premiumCars: "Premium Cars",
        sellCar: "Sell Your Car",
        priceCalculator: "Price Calculator",
        certifiedCars: "Autofinder Certified Cars",
        inspection: "Autofinder Car Inspection",
        listIt: "Autofinder List It For You",
        findNewCars: "Find New Cars",
        carComparisons: "Car Comparisons",
        prices: "Prices",
        onRoadPrice: "On Road Price",
        findUsedBikes: "Find Used Bikes",
        usedBikesListings: "Used Bikes Listings",
        premiumBikes: "Premium Bikes",
        sellBike: "Sell Your Bike",
        findNewBikes: "Find New Bikes",
        newBikesPrices: "New Bikes Prices",
        autofinderStore: "Autofinder Autostore",
        findAutoParts: "Find Auto Parts",
        sellCarParts: "Sell Car Parts",
        dealerPackages: "Dealer Packages",
        faqs: "FAQ's",
        videos: "Videos",
        forums: "Forums",
        contactUs: "Contact Us",
        help: "Help",
        aboutUs: "About Us",
        privacyPolicy: "Privacy Policy",
        compare: "Compare",
        carOnRent: "Car on Rent",
        buyCarForMe: "Buy Car for Me",
        profile: "Profile",
        myAds: "My Ads",
        myPackages: "My Packages",
        logout: "Logout",
        lightMode: "Light Mode",
        darkMode: "Dark Mode",
        // Home Page
        heroTitle: "SEARCH THE RIGHT CAR",
        newCar: "NEW CAR",
        usedCar: "USED CAR",
        byBudget: "BY BUDGET",
        byModel: "BY MODEL",
        priceRange: "Price Range",
        selectBudget: "SELECT BUDGET",
        selectCity: "SELECT CITY",
        selectModel: "SELECT MODEL",
        search: "SEARCH",
        advancedSearch: "ADVANCED SEARCH",
        sellCarDataTitle: "Sell Your Car on Autofinder and Get the Best Price",
        sellItMyself: "Sell It Myself!",
        diySeller: "DIY Seller • Fast",
        diyDesc: "Perfect if you want full control and quick posting.",
        postAdTime: "Post an ad in 2 minutes",
        userCount: "20 million users",
        connectBuyers: "Connect directly with buyers",
        postYourAd: "Post Your Ad",
        carInspection: "Car Inspection",
        professionalService: "Professional Service",
        inspectionDesc: "Get your car professionally inspected by certified experts for peace of mind.",
        expertInspection: "Certified expert inspection",
        report: "Detailed condition report",
        guarantee: "Buyer confidence guarantee",
        // Car Detail
        loadingCarDetails: "Loading Car Details",
        carNotFound: "Car Not Found",
        carNotFoundDesc: "The car you are looking for does not exist.",
        browseNewCars: "Browse New Cars",
        goBack: "Go Back",
        featured: "Featured",
        transmission: "Transmission",
        engine: "Engine",
        fuelType: "Fuel Type",
        color: "Color",
        seats: "Seats",
        driveType: "Drive Type",
        contactDealer: "Contact Dealer",
        overview: "Overview",
        specifications: "Specifications",
        pictures: "Pictures",
        carOverview: "Car Overview",
        engineCapacity: "Engine Capacity",
        loadingUsedCarDetails: "Loading Used Car Details",
        browseUsedCars: "Browse Used Cars",
        managedByAutofinder: "Managed by AutoFinder",
        premium: "Premium",
        freeAd: "Free Ad",
        carDescription: "Car Description",
        additionalDetails: "Additional Details",
        registrationCity: "Registration City",
        condition: "Condition",
        contactSeller: "Contact Seller",
        mileage: "Mileage",
        selectCity: "Select City",
        searchCity: "Search city...",
        noCityFound: "No city found",
        selectMake: "Select Make",
        searchMake: "Search make...",
        noMakeFound: "No make found",
        selectModel: "Select Model",
        selectMakeFirst: "Select Make first",
        searchModel: "Search model...",
        noModelFound: "No model found",
        selectVariant: "Select Variant",
        selectMakeAndModelFirst: "Select Make & Model first",
        searchVariant: "Search variant...",
        noVariantFound: "No variant found",
        postAnAd: "Post an Ad",
        selectPackage: "Select Package",
        validity: "Validity",
        kmDriven: "KM Driven",
        preferredContact: "Preferred Contact",
        mobile: "Mobile",
        featuredAds: "Featured Ads",
        freeAds: "Free Ads",
        price: "Price",
        location: "Location",
        description: "Description",
        bodyColor: "Body Color",
        postAdTime: "Post an ad in 2 minutes",
        chooseService: "Choose Service",
        freeAdService: "Free Ad",
        premiumAdService: "Premium Ad",
        listItService: "List It For You",
        sellFaster: "Sell Faster",
        allFeatures: "All Features",
        select: "Select",
        next: "Next",
        back: "Back",
        finish: "Finish",
        step: "Step",
        adDetails: "Ad Details",
        contactDetails: "Contact Details",
        uploadPhotos: "Upload Photos",
        transmissionLabel: "Transmission",
        fuelTypeLabel: "Fuel Type",
        bodyTypeLabel: "Body Type",
        engineCapacityLabel: "Engine Capacity",
        assemblyLabel: "Assembly",
        doorsLabel: "Doors",
        yearLabel: "Year",
        makeLabel: "Make",
        modelLabel: "Model",
        variantLabel: "Variant",
        selectYear: "Select Year",
        days: "days",
        selectFuelType: "Select Fuel Type",
        selectTransmission: "Select Transmission",
        selectBodyType: "Select Body Type",
        selectAssembly: "Select Assembly",
        selectColor: "Select Color",
        petrol: "Petrol",
        diesel: "Diesel",
        hybrid: "Hybrid",
        electric: "Electric",
        cng: "CNG",
        lpg: "LPG",
        automatic: "Automatic",
        manual: "Manual",
        descriptionLabel: "Description",
        featuresLabel: "Features",
        imagesLabel: "Images",
        upTo20Images: "(Up to 20 images)",
        max10Images: "(Max 10 images)",
        airconditioning: "Air Conditioning",
        abs: "ABS",
        airbags: "Airbags",
        sunroof: "Sunroof",
        bluetooth: "Bluetooth",
        cruisecontrol: "Cruise Control",
        parkingsensors: "Parking Sensors",
        navigation: "Navigation",
        leatherseats: "Leather Seats",
        heatedseats: "Heated Seats",
        rearcamera: "Rear Camera",
        keylessentry: "Keyless Entry",
        alloywheels: "Alloy Wheels",
        foglights: "Fog Lights",
        touchscreen: "Touchscreen",
        powersteering: "Power Steering",
        powerwindows: "Power Windows",
        selectPremiumPackage: "Select Premium Package",
        loadingPackages: "Loading packages...",
        noPackagesAvailable: "No packages available at the moment.",
        popular: "POPULAR",
        youSave: "You Save:",
        validity: "Validity:",
        totalAds: "Total Ads:",
        freeBoosters: "Free Boosters:",
        selectPackage: "Select Package",
        createPremiumAd: "Create Premium Car Ad",
        selectedPackageLabel: "Selected Package:",
        titleLabel: "Title",
        pricePkr: "Price (PKR)",
        kmDrivenLabel: "KM Driven",
        mileageLabel: "Mileage",
        paymentInvoiceOptional: "Payment Invoice Image (Optional)",
        postFreeAdBtn: "Post Free Ad",
        creatingAd: "Creating Ad...",
        titlePlaceholder: "e.g., Toyota Corolla 2020",
        pricePlaceholder: "e.g., 2500000",
        kmPlaceholder: "e.g., 50000",
        capacityPlaceholder: "e.g., 1800",
        descriptionPlaceholder: "Describe your car...",
        cancel: "Cancel",
        createFreeAd: "Create Free Car Ad",
        freeAdLimitCompleted: "Free Ad Limit Completed",
        freeAdLimitDesc: "You've used all your free ads. Fill the form below and upload payment receipt for PKR 525 to continue.",
        freeAdLimitNote: "After 2 free ads, each additional ad costs PKR 525. This amount will be adjusted from any premium service you purchase later.",
        standardAdPackage: "Standard Ad Package",
        standardAdDesc: "Create your car listing with standard visibility",
        standardVisibility: "Standard listing visibility",
        activeAfterVerification: "Ad will be active after payment verification",
        amountAdjustable: "Amount adjustable from premium services",
        paymentDetails: "Payment Details",
        easypaisaJazzcash: "EasyPaisa | JazzCash",
        accountNumber: "Account Number",
        accountName: "Account Name",
        copy: "Copy",
        paymentReceipt: "Payment Receipt",
        uploadReceiptDesc: "Upload your payment receipt for PKR 525. Ad will be activated after admin verification.",
        carDetails: "Car Details",
        backToAllServices: "← Back to All Services",
        autofinderServices: "Autofinder Services",
        sellYourCarFree: "SELL YOUR CAR FREE",
        premiumCarAd: "PREMIUM CAR AD",
        freeAdDesc: "Create your listing in minutes. Access a trusted community of 20+ million. Engage directly with serious buyers.",
        premiumAdDesc: "Get premium visibility with featured listing. Your ad will be highlighted and shown to more buyers.",
        Weston: "Weston",
        // Footer
        footerAbout: "Auto Finder is Pakistan's leading online marketplace for buying and selling cars. We connect buyers and sellers, making car transactions easy, safe, and convenient. Browse thousands of verified car listings, compare prices, and find your perfect vehicle with our comprehensive search and filter options.",
        usefulLinks: "Useful Links",
        latestCars: "Latest Cars",
        upcomingCars: "Upcoming Cars",
        searchUsedCar: "Search Used Car",
        carSell: "Car Sell",
        compareCar: "Compare Car",
        recentPosts: "Recent Posts",
        newsletter: "Newsletter",
        newsletterDesc: "Keep up on our always evolving products features and technology. Enter your e-mail and subscribe to our newsletter.",
        enterEmail: "Enter your email",
        subscribe: "SUBSCRIBE",
        subscribing: "Subscribing...",
        copyright: "© Copyright 2025 Developed by",
        phone: "Phone :",
        email: "Email :",
        timeToChange: "Time to change...",
        aboutUs: "About Us",
        contactUs: "Contact Us",
        help: "Help",
        privacyPolicy: "Privacy Policy",
        // Filters & Dropdowns
        from: "From",
        to: "To",
        go: "Go",
        lacs: "Lacs",
        crore: "Crore",
        thousand: "K",
        any: "Any",
        all: "All",
        select: "Select",
        // Common Filters
        make: "Make",
        model: "Model",
        year: "Year",
        mileage: "Mileage",
        condition: "Condition",
        transmission: "Transmission",
        fuelType: "Fuel Type",
        bodyType: "Body Type",
        engineCapacity: "Engine Capacity",
        registered: "Registered",
        assembly: "Assembly",
        // Actions
        filter: "Filter",
        sort: "Sort",
        reset: "Reset",
        apply: "Apply",
        clear: "Clear",
        viewDetails: "View Details",
        viewMore: "View More",
        loadMore: "Load More",
        // Car Details
        specifications: "Specifications",
        features: "Features",
        description: "Description",
        contactSeller: "Contact Seller",
        share: "Share",
        report: "Report",
        viewPhone: "View Phone Number",
        sendMessage: "Send Message",
        makeOffer: "Make an Offer",
        // Form Labels
        name: "Name",
        phone: "Phone",
        message: "Message",
        address: "Address",
        submit: "Submit",
        cancel: "Cancel",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        update: "Update",
        upload: "Upload",
        // Auth
        password: "Password",
        confirmPassword: "Confirm Password",
        forgotPassword: "Forgot Password?",
        rememberMe: "Remember Me",
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: "Already have an account?",
        // Car Specs
        color: "Color",
        doors: "Doors",
        seats: "Seats",
        owner: "Owner",
        location: "Location",
        postedOn: "Posted On",
        adId: "Ad ID",
        // Sort Options
        sortBy: "Sort By",
        priceLowToHigh: "Price: Low to High",
        priceHighToLow: "Price: High to Low",
        newest: "Newest First",
        oldest: "Oldest First",
        mileageLowToHigh: "Mileage: Low to High",
        // Messages
        noCarsFound: "No cars found",
        noResultsFound: "No results found",
        loading: "Loading...",
        tryAdjustingFilters: "Try adjusting your filters",
        // Pagination
        previous: "Previous",
        next: "Next",
        page: "Page",
        of: "of",
        showing: "Showing",
        results: "results",
        // YouTube Section
        shortsAndVideos: "Shorts & Videos",
        // News Section
        latestNews: "Latest News",
        readMore: "Read More",
        // Car Listing & Details
        featured: "Featured",
        managedBy: "Managed by",
        viewAllCars: "View All Cars",
        noBidsYet: "No bids yet",
        highestBid: "Highest Bid",
        placeBid: "Place Bid",
        buyNow: "Buy Now",
        // Sidebar Filters - Headers
        filters: "Filters",
        byCity: "By City",
        byProvince: "By Province",
        byMake: "By Make",
        byModel: "By Model",
        byYear: "By Year",
        byPrice: "By Price",
        byMileage: "By Mileage",
        byBodyType: "By Body Type",
        byFuelType: "By Fuel Type",
        byTransmission: "By Transmission",
        byColor: "By Color",
        byAssembly: "By Assembly",
        // Provinces
        punjab: "Punjab",
        sindh: "Sindh",
        kpk: "KPK",
        balochistan: "Balochistan",
        islamabadCapital: "Islamabad Capital",
        azadKashmir: "Azad Kashmir",
        // Transmission Types
        automatic: "Automatic",
        manual: "Manual",
        // Fuel Types
        petrol: "Petrol",
        diesel: "Diesel",
        hybrid: "Hybrid",
        electric: "Electric",
        cng: "CNG",
        lpg: "LPG",
        // Body Types
        sedan: "Sedan",
        hatchback: "Hatchback",
        suv: "SUV",
        crossover: "Crossover",
        coupe: "Coupe",
        convertible: "Convertible",
        wagon: "Wagon",
        van: "Van",
        minivan: "Minivan",
        pickup: "Pickup",
        truck: "Truck",
        // Assembly Types
        local: "Local",
        imported: "Imported",
        // Colors
        white: "White",
        black: "Black",
        silver: "Silver",
        grey: "Grey",
        gray: "Gray",
        red: "Red",
        blue: "Blue",
        green: "Green",
        brown: "Brown",
        gold: "Gold",
        unlisted: "Unlisted",
        // Car Specifications
        kmDriven: "KM Driven",
        km: "KM",
        cc: "CC",
        registeredIn: "Registered In",
        trustedCars: "Trusted Cars",
        inspected: "Inspected",
        certified: "Certified",
        numberOfDoors: "Number of Doors",
        seatingCapacity: "Seating Capacity",
        // Sell Car Page
        carInformation: "Car Information",
        uploadPhotos: "Upload Photos",
        contactInformation: "Contact Information",
        selectMake: "Select Make",
        selectModel: "Select Model",
        selectYear: "Select Year",
        enterPrice: "Enter Price",
        enterMileage: "Enter Mileage",
        selectColor: "Select Color",
        selectTransmission: "Select Transmission",
        selectFuelType: "Select Fuel Type",
        selectBodyType: "Select Body Type",
        selectAssembly: "Select Assembly",
        enterEngineCapacity: "Enter Engine Capacity",
        selectRegisteredCity: "Select Registered City",
        adTitle: "Ad Title",
        adDescription: "Ad Description",
        // Profile & My Ads
        myProfile: "My Profile",
        editProfile: "Edit Profile",
        changePassword: "Change Password",
        myFavorites: "My Favorites",
        savedSearches: "Saved Searches",
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        expired: "Expired",
        sold: "Sold",
        // Time & Date
        today: "Today",
        yesterday: "Yesterday",
        daysAgo: "days ago",
        weeksAgo: "weeks ago",
        monthsAgo: "months ago",
        yearsAgo: "years ago",
        // Common Phrases
        viewAll: "View All",
        seeMore: "See More",
        seeLess: "See Less",
        showMore: "Show More",
        showLess: "Show Less",
        backToTop: "Back to Top",
        goBack: "Go Back",
        continue: "Continue",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        ok: "OK",
        close: "Close",
        // Error & Success Messages
        error: "Error",
        success: "Success",
        warning: "Warning",
        info: "Info",
        pleaseWait: "Please wait...",
        processingRequest: "Processing your request...",
        somethingWentWrong: "Something went wrong",
        tryAgain: "Try again",
        required: "Required",
        optional: "Optional",
        invalidEmail: "Invalid email address",
        invalidPhone: "Invalid phone number",
        passwordTooShort: "Password too short",
        passwordsDoNotMatch: "Passwords do not match",
        // Auth Messages
        welcomeBack: "Welcome Back",
        signInToAccount: "Sign in to your Autofinder account",
        emailOrPhone: "Email or Phone",
        enterEmailOrPhone: "Enter your email or phone",
        enterPassword: "Enter your password",
        signingIn: "Signing In...",
        pleaseEnterEmailAndPassword: "Please enter both email/phone and password",
        loginSuccessful: "Login successful!",
        loginFailedCheckCredentials: "Login failed. Please check your credentials.",
        errorDuringLogin: "An error occurred during login. Please try again.",
        createAccount: "Create Account",
        signUpToGetStarted: "Sign up to get started with Autofinder",
        fullName: "Full Name",
        enterFullName: "Enter your full name",
        emailAddress: "Email Address",
        enterEmail: "Enter your email",
        phoneNumber: "Phone Number",
        enterPhoneNumber: "Enter your phone number",
        enterPasswordMinChars: "Enter your password (min 8 characters)",
        confirmYourPassword: "Confirm your password",
        creatingAccount: "Creating Account...",
        clickToUploadProfile: "Click to upload profile picture (Optional)",
        passwordMustBe8Chars: "Password must be at least 8 characters",
        imageSizeLessThan5MB: "Image size should be less than 5MB",
        pleaseFillAllFields: "Please fill in all required fields",
        passwordMustBe8CharsLong: "Password must be at least 8 characters long",
        pleaseEnterValidEmail: "Please enter a valid email address",
        accountCreatedSuccessfully: "Account created successfully! Please login to continue.",
        signupFailed: "Signup failed. Please try again.",
        errorDuringSignup: "An error occurred during signup. Please try again.",
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: "Already have an account?",
        forgotPassword: "Forgot Password?",
        confirmPassword: "Confirm Password",
        // Used Cars & Filters
        usedCars: "Used Cars",
        findUsedCars: "Find Used Cars",
        allCars: "All Cars",
        allPrices: "All Prices",
        allYears: "All Years",
        allMileage: "All Mileage",
        allColors: "All Colors",
        sortBy: "Sort By",
        priceHighToLow: "Price: High to Low",
        priceLowToHigh: "Price: Low to High",
        yearNewestFirst: "Year: Newest First",
        yearOldestFirst: "Year: Oldest First",
        mileageLowToHigh: "Mileage: Low to High",
        mileageHighToLow: "Mileage: High to Low",
        results: "Results",
        carsFound: "Cars Found",
        noCarsFound: "No cars found",
        clearFilters: "Clear Filters",
        applyFilters: "Apply Filters",
        // Car Detail
        carDetails: "Car Details",
        specifications: "Specifications",
        features: "Features",
        description: "Description",
        sellerInfo: "Seller Information",
        contactSeller: "Contact Seller",
        makeOffer: "Make an Offer",
        reportAd: "Report Ad",
        shareAd: "Share Ad",
        similarCars: "Similar Cars",
        // Sell Car
        sellYourCar: "Sell Your Car",
        postYourAd: "Post Your Ad",
        adPostedSuccessfully: "Ad posted successfully!",
        fillAllRequiredFields: "Please fill all required fields",
        // Profile & Dashboard
        dashboard: "Dashboard",
        myAccount: "My Account",
        accountSettings: "Account Settings",
        notifications: "Notifications",
        messages: "Messages",
        logout: "Logout",
        // Services
        ourServices: "Our Services",
        carInspection: "Car Inspection",
        bookInspection: "Book Inspection",
        inspectionBooked: "Inspection booked successfully!",
        // Contact
        contactUs: "Contact Us",
        getInTouch: "Get in Touch",
        sendMessage: "Send Message",
        yourMessage: "Your Message",
        messageSent: "Message sent successfully!",
        // Common Actions
        viewDetails: "View Details",
        loadMore: "Load More",
        refresh: "Refresh",
        download: "Download",
        share: "Share",
        copy: "Copy",
        copied: "Copied!",
        // Profile Page
        myProfile: "My Profile",
        backToDashboard: "Back to Dashboard",
        editProfile: "Edit Profile",
        saveChanges: "Save Changes",
        gender: "Gender",
        male: "Male",
        female: "Female",
        other: "Other",
        dateOfBirth: "Date of Birth",
        country: "Country",
        city: "City",
        username: "Username",
        email: "Email",
        verified: "Verified",
        notVerified: "Not Verified",
        addNumber: "Add Number",
        verifyEmail: "Verify Email",
        emailVerificationDesc: "You have not verified your email address. You can resend verification email by",
        clickingHere: "clicking here",
        resendVerificationEmail: "Resend Verification Email",
        sending: "Sending...",
        otpSent: "OTP sent to your email! Please check your inbox.",
        enterOtp: "Enter OTP",
        verifyOtp: "Verify OTP",
        resend: "Resend",
        otpVerification: "OTP Verification",
        otpVerificationDesc: "We've sent a 6-digit OTP to your email. Please enter it below to verify your email.",
        profileUpdated: "Profile updated successfully!",
        noChangesDetected: "No changes detected. Please modify at least one field before saving.",
        imageSizeLimit: "Image size should be less than 5MB",
        maxSize: "Max size:",
        selectGender: "Select Gender",
        selectCountry: "Select Country",
        selectCity: "Select City",
        // My Ads
        myAds: "My Ads",
        activeAds: "Active Ads",
        pendingAds: "Pending Ads",
        rejectedAds: "Rejected Ads",
        noAdsFound: "No ads found",
        manageAds: "Manage Ads",
        editAd: "Edit Ad",
        deleteAd: "Delete Ad",
        boostAd: "Boost Ad",
        status: "Status",
        views: "Views",
        postNewAd: "Post New Ad",
        postYourFirstAd: "Post Your First Ad",
        allAdsCount: "All ({{count}})",
        activeAdsCount: "Active ({{count}})",
        pendingAdsCount: "Pending ({{count}})",
        inactiveAdsCount: "Inactive ({{count}})",
        noAdsDescription: "You haven't posted any ads yet.",
        noFilteredAdsDescription: "You don't have any {{filter}} ads.",
        untitledAd: "Untitled Ad",
        posted: "Posted",
        deleteConfirm: "Are you sure you want to delete this ad? This action cannot be undone.",
        adDeletedSuccess: "Ad deleted successfully",
        adDeleteFailed: "Failed to delete ad",
        // Edit Ad
        editAdTitle: "Edit Ad",
        saving: "Saving...",
        adUpdatedSuccess: "Ad updated successfully!",
        adUpdateFailed: "Failed to update ad",
        selectMakeFirst: "Select Make first",
        selectMakeModelFirst: "Select Make & Model first",
        searchCity: "Search city...",
        noCityFound: "No city found",
        searchMake: "Search make...",
        noMakeFound: "No make found",
        searchModel: "Search model...",
        noModelFound: "No model found",
        searchVariant: "Search variant...",
        noVariantFound: "No variant found",
        updateAd: "Update Ad",
        maxImagesAllowed: "Maximum 10 images allowed",
        fillRequiredFields: "Please fill in all required fields",
        uploadAtLeastOneImage: "Please upload at least one image",
        loginToEditAd: "Please login to edit your ad",
        adNotFound: "Ad not found. It may have been deleted or the ID is incorrect.",
        // Ad Types
        featuredCar: "Featured Car",
        listItForYouBadge: "List It For You",
        freeAdBadgeShort: "Free Ad",
        autoPartsBadge: "Auto Parts",
        newCarBadge: "New Car",
        newBikeBadge: "New Bike",
        rentCarBadge: "Rent Car",
        premiumBikeBadge: "Premium Bike",
        // Status
        loading: "Loading...",
        noData: "No data available",
        comingSoon: "Coming Soon",
        new: "New",
        premium: "Premium",
        // Section Headings
        browseUsedCars: "Browse Used Cars",
        forYourQuickLook: "For Your Quick Look",
        autofinderServices: "Autofinder Services",
        premiumSolutions: "Premium Solutions for every car owner",
        // Filter Tabs
        category: "Category",
        city: "City",
        make: "Make",
        model: "Model",
        budget: "Budget",
        bodyType: "Body Type",
        // Tab Buttons
        managedByAutofinder: "Managed By Autofinder",
        popularNewCars: "Popular New Cars",
        premiumCars: "Premium Cars",
        premiumBikes: "Premium Bikes",
        rentCar: "Rent Car",
        autoStore: "Auto Store",
        // Service Cards
        freeAd: "Free Ad",
        premiumAd: "Premium Ad",
        buyForMe: "Buy For Me",
        listForYou: "List For You",
        inspection: "Inspection",
        carOnRent: "Car On Rent",
        exploreMore: "Explore More",
        // Service Descriptions
        freeAdDesc: "Easiest way to sell your car at the best price.",
        premiumAdDesc: "Boost your car's visibility with featured listings. Our premium ads help you sell your car 5x faster than normal ads.",
        buyForMeDesc: "Let our expert consultants find, inspect and negotiate the best car deal for you based on your needs.",
        listForYouDesc: "Relax while we sell your car. From professional photography to closing the deal, we manage everything.",
        inspectionDesc: "Get a detailed car inspection report delivered right to the comfort of your home. Buy with confidence.",
        carOnRentDesc: "Choose from a wide range of premium vehicles available for flexible short and long term rental options.",
        // Error Messages
        unableToLoad: "Unable to load",
        errorFailedToFetch: "Error: Failed to fetch",
        retry: "Retry",
        tryAnotherFilter: "Try Another Filter",
        noCarsAvailable: "No cars available",
        or: "OR",
        // Final Sweep Keys
        aboutUsTitle: "About us",
        aboutDesc1: "Autofinder is a complete automotive platform designed to make buying, selling, renting, and inspecting vehicles easier, faster, and more reliable.",
        aboutDesc2: "Our goal is to provide users with a transparent and hassle-free car experience by offering a range of professional services in one place. Whether you're looking to purchase your dream car, sell your current vehicle, rent a car for a special occasion, or get a professional vehicle inspection, Auto Finder is here to help.",
        aboutDesc3: "Our commitment to transparency, reliability, and customer satisfaction sets us apart. We believe that everyone deserves a smooth and stress-free automotive experience, and we're dedicated to making that a reality for all our users.",
        haveAnyQuestion: "Have any question ?",
        areYouLookingToBuyACar: "Are You Looking To Buy A Car ?",
        ctaDesc1: "Find your car from",
        ctaDesc2: "options. Best prices, verified sellers, and 24/7 support.",
        searchYourCar: "Search Your Car",
        moreChoices: "more choices...",
        byCity: "By City",
        byPrice: "By Price",
        loadingStats: "Loading statistics...",
        thousandsOf: "thousands of",
        options: "options",
        province: "Province",
        registeredIn: "Registered In",
        trustedCars: "Trusted Cars",
        engineType: "Engine Type",
        assembly: "Assembly",
        doors: "Doors",
        seatingCapacity: "Seating Capacity",
        resetAll: "Reset All",
        showing: "Showing",
        carBadge: "car",
        carsBadge: "cars",
        filtered: "filtered",
        loadingUsedCars: "Loading used cars...",
        unableToLoadUsedCars: "Unable to load used cars",
        noUsedCarsFound: "No used cars found",
        trySelectingDifferentFilters: "Try selecting different filters",
        managed: "Managed",
        premium: "Premium",
        freeAdBadge: "Free Ad",
        yearLabelField: "Year:",
        transLabelField: "Trans:",
        engineLabelField: "Engine:",
        mileageLabelField: "Mileage:",
        priceOnCall: "Price on call",
        sorryNoCarsFor: "Sorry, there are no cars available for",
        inKeyword: "in",
        atTheMoment: "at the moment.",
        subscribeSuccess: "Successfully subscribed to newsletter!",
        subscribeFailed: "Subscription failed. Please try again.",
        validEmailError: "Please enter a valid email address",
        emailRequiredError: "Please enter your email address",
        thankYouSubscribe: "Thank you for subscribing!",
        by: "By",
        viewDetails: "View Details",
        new: "NEW",
        showResultsBy: "SHOW RESULTS BY",
        clearFilters: "Clear Filters",
        go: "Go",
        searchByMakeModelCity: "e.g. Honda in Lahore",
        pkr: "PKR",
        // Budget Ranges
        under5Lakh: "Under 5 Lakh",
        "5_10Lakh": "5-10 Lakh",
        "10_15Lakh": "10-15 Lakh",
        // FAQ Page
        faqTitle: "Frequently Asked Questions",
        q1: "How do I search for a car?",
        a1: "You can search for cars using our search filters. Select the brand, model, budget, and other preferences to find the perfect car for you.",
        q2: "Can I compare different cars?",
        a2: "Yes, you can compare up to 3 cars side by side. Just click on the compare button on any car detail page.",
        q3: "How do I contact a dealer?",
        a3: "You can contact dealers directly through the car detail page. Click on the \"Contact Dealer\" button to get in touch.",
        q4: "What payment methods do you accept?",
        a4: "We accept various payment methods including cash, bank transfer, and financing options. Contact the dealer for more details.",
        q5: "Do you offer car financing?",
        a5: "Yes, many of our dealers offer financing options. Please contact them directly to discuss financing plans.",
        // About Page
        welcomeToAutoFinder: "Welcome to Auto Finder",
        aboutMission: "Our Mission",
        aboutVision: "Our Vision",
        aboutValues: "Our Values",
        missionDesc: "To make buying, selling, renting, and inspecting vehicles easier, faster, and more reliable for everyone.",
        visionDesc: "To be the leading complete automotive platform that provides transparent and hassle-free car experiences.",
        valuesDesc: "Transparency, reliability, customer satisfaction, and providing professional services in one convenient place.",
        // Help Page
        helpSupport: "Help & Support",
        helpDesc: "Get help and support for Auto Finder. Find answers to common questions, contact our support team, and learn how to use our platform.",
        contactSupport: "Contact Support",
        phoneSupport: "Phone Support",
        emailSupport: "Email Support",
        officeAddress: "Office Address",
        support247: "24/7 Support Line",
        hqAddress: "G9 Markaz, Islamabad, Pakistan",
        hqEmail: "autofinder786@gmail.com",
        hqPhone: "+92 334 8400943",
        hqEmailLink: "mailto:autofinder786@gmail.com",
        hqPhoneLink: "tel:+923348400943",
        hqAddressLabel: "G9 Markaz, Islamabad, Pakistan",
        hqEmailLabel: "autofinder786@gmail.com",
        hqPhoneLabel: "+92 334 8400943",
        // Help FAQ Qs
        hq_q1: "How do I post an ad?",
        hq_a1: "To post an ad, click on \"Post an Ad\" in the header menu, then select \"Sell Your Car\" or \"Sell Your Bike\". Choose between a free ad or premium ad, fill in the required details, upload images, and submit your ad. Premium ads require payment verification and will be reviewed by our admin team.",
        hq_q2: "What is the difference between free and premium ads?",
        hq_a2: "Free ads are posted immediately and are visible to all users. Premium ads offer enhanced visibility, featured placement, and priority in search results. Premium ads require payment verification and admin approval before going live.",
        hq_q3: "How do I edit or delete my ad?",
        hq_a3: "Go to \"My Ads\" in your profile menu. You'll see all your posted ads with options to edit or delete them. Click on \"Edit\" to modify your ad details, or \"Delete\" to remove your ad permanently.",
        hq_q4: "What are dealer packages?",
        hq_a4: "Dealer packages are subscription plans that allow you to post multiple ads and use boost features. Packages include a certain number of ads and boosters that you can use within the package validity period. You can purchase packages from the \"Dealer Packages\" section in the menu.",
        hq_q5: "How do I contact a seller?",
        hq_a5: "On any car or bike detail page, you'll find the seller's contact information including phone number and email. You can contact them directly using the provided contact details.",
        hq_q6: "How do I search for cars or bikes?",
        hq_a6: "Use the search bar in the header or navigate to \"Used Cars\", \"Latest Cars\", \"Used Bikes\", or \"New Bikes\" sections. You can filter results by make, model, price range, city, body type, and other criteria using the filter options on the left sidebar.",
        hq_q7: "What payment methods are accepted?",
        hq_a7: "We accept payments through EasyPaisa and JazzCash. After selecting a package or premium ad, you'll be prompted to choose your payment method and upload a payment receipt for admin verification.",
        hq_q8: "How long does it take for my premium ad to be approved?",
        hq_a8: "Premium ads typically go live within 24 hours after payment verification. Our admin team reviews all premium ads and payment receipts to ensure authenticity before approval.",
        // Privacy Policy Page
        ppTitle: "Privacy Policy",
        lastUpdated: "Last Updated",
        ppIntro: "Auto Finder (\"we\", \"our\", or \"us\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.",
        ppSection1Title: "1. Information We Collect",
        ppSection1Text1: "Personal Information: We collect information that you provide directly to us, including your name, email address, phone number, and profile information when you create an account or post an ad.",
        ppSection1Text2: "Ad Information: When you post an ad, we collect information about the vehicle including make, model, year, price, images, and description.",
        ppSection1Text3: "Payment Information: For premium ads and packages, we collect payment receipt information for verification purposes. We do not store full payment details.",
        ppSection1Text4: "Usage Data: We automatically collect information about how you interact with our website, including IP address, browser type, pages visited, and time spent on pages.",
        ppSection2Title: "2. How We Use Your Information",
        ppSection2Item1: "To provide, maintain, and improve our services",
        ppSection2Item2: "To process your ad postings and manage your account",
        ppSection2Item3: "To verify payments and process premium ad approvals",
        ppSection2Item4: "To communicate with you about your account, ads, and our services",
        ppSection2Item5: "To send you updates, newsletters, and promotional materials (with your consent)",
        ppSection2Item6: "To respond to your inquiries and provide customer support",
        ppSection2Item7: "To detect, prevent, and address technical issues and fraudulent activities",
        ppSection2Item8: "To comply with legal obligations and enforce our terms of service",
        ppSection3Title: "3. Information Sharing and Disclosure",
        ppSection3Text1: "We do not sell your personal information. We may share your information in the following circumstances:",
        ppSection3Item1: "Public Ad Information: Information you include in your ads (vehicle details, images, contact information) will be visible to all users of our platform.",
        ppSection3Item2: "Service Providers: We may share information with third-party service providers who assist us in operating our website and conducting our business.",
        ppSection3Item3: "Legal Requirements: We may disclose information if required by law or in response to valid requests by public authorities.",
        ppSection3Item4: "Business Transfers: In the event of a merger, acquisition, or sale of assets, your information may be transferred to the acquiring entity.",
        ppSection4Title: "4. Data Security",
        ppSection4Text: "We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
        ppSection5Title: "5. Your Rights and Choices",
        ppSection5Text1: "You have the right to:",
        ppSection5Item1: "Access and update your personal information through your account settings",
        ppSection5Item2: "Delete your account and associated data",
        ppSection5Item3: "Edit or delete your posted ads",
        ppSection5Item4: "Opt-out of promotional communications by unsubscribing from our emails",
        ppSection5Item5: "Request a copy of your personal data",
        ppSection6Title: "6. Cookies and Tracking Technologies",
        ppSection6Text: "We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.",
        ppSection7Title: "7. Third-Party Links",
        ppSection7Text: "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.",
        ppSection8Title: "8. Children's Privacy",
        ppSection8Text: "Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.",
        ppSection9Title: "9. Changes to This Privacy Policy",
        ppSection9Text: "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the \"Last Updated\" date. You are advised to review this Privacy Policy periodically for any changes.",
        ppSection10Title: "10. Contact Us",
        ppSection10Text: "If you have any questions about this Privacy Policy, please contact us:",
        // Contact Us Page Add-ons
        contactUsPageTitle: "Contact Us",
        sendMessageTitle: "Send Message",
        getInTouchTitle: "Get in Touch",
        contactAddress: "Address",
        contactPhone: "Phone",
        contactEmail: "Email",
        fullName: "Full Name",
        emailAddress: "Email Address",
        phoneOptional: "Phone (Optional)",
        howCanWeHelp: "How can we help?",
        yourNamePlaceholder: "Your Name",
        yourEmailPlaceholder: "Your Email",
        phonePlaceholder: "Phone Number",
        messageSentSuccess: "Your message has been sent successfully!",
        messageSendError: "Failed to send your message. Please try again.",
        // Blog Page Add-ons
        latestNews: "Latest News",
        readLatestNews: "Read our latest news and updates",
        noBlogsAvailable: "No blog posts available at the moment.",
        checkBackLater: "Check back later for updates.",
        readMore: "Read More",
        adminAuthor: "Admin",
        dateNotAvailable: "Date not available",
        blogTitleSuffix: "| Auto Finder",
        // Auto Store Page
        byCategory: "By Category",
        allCategories: "All Categories",
        engineParts: "Engine Parts",
        bodyParts: "Body Parts",
        electrical: "Electrical",
        interior: "Interior",
        exterior: "Exterior",
        accessories: "Accessories",
        tiresWheels: "Tires & Wheels",
        brakeSystem: "Brake System",
        suspension: "Suspension",
        transmission: "Transmission",
        other: "Other",
        searchByPartName: "Search by part name...",
        itemsFound: "Items Found",
        "15_20Lakh": "15-20 Lakh",
        "20_30Lakh": "20-30 Lakh",
        "30_50Lakh": "30-50 Lakh",
        "50_75Lakh": "50-75 Lakh",
        "75Lakh_1Crore": "75 Lakh - 1 Crore",
        above1Crore: "Above 1 Crore",
        // Compare Cars
        compareCarsTitle: "New Cars Comparison",
        compareCarsSubtitle: "Confused? Compare your choice of cars",
        selectCar: "Select Car",
        specification: "Specification",
        hotComparisons: "Hot Car Comparisons",
        vs: "VS",
        done: "Done",
        versionOptional: "VERSION (OPTIONAL)",
        selectMakeAndModelFirst: "Select Make and Model first",
        pleaseSelectMakeAndModel: "Please select Make and Model",
        searchByMakeModelVersion: "Make/Model/Version",
        noVariantsAvailable: "No variants available",
        lacs: "Lacs"
    },
    ur: {
        signUp: "سائن اپ",
        signIn: "سائن ان",
        home: "گھر",
        services: "خدمات",
        contact: "رابطہ",
        shorts: "شارٹس",
        viewMore: "یوٹیوب پر مزید دیکھیں",
        downloadApp: "ایپ ڈاؤن لوڈ کریں",
        urdu: "اردو",
        english: "انگریزی",
        searchPlaceholder: "تلاش کریں...",
        usedCars: "استعمال شدہ کاریں",
        newCars: "نئی کاریں",
        bikes: "موٹر سائیکلیں",
        autoStore: "آٹو اسٹور",
        blog: "بلاگ",
        more: "مزید",
        postAd: "اشتہار لگائیں",
        findUsedCars: "استعمال شدہ کاریں تلاش کریں",
        premiumCars: "پریمیم کاریں",
        sellCar: "اپنی کار بیچیں",
        priceCalculator: "قیمت کیلکولیٹر",
        certifiedCars: "آٹوفائنڈر تصدیق شدہ کاریں",
        inspection: "آٹوفائنڈر کار انسپکشن",
        listIt: "آٹوفائنڈر آپ کے لیے لسٹ کرے گا",
        findNewCars: "نئی کاریں تلاش کریں",
        carComparisons: "کار کا موازنہ",
        prices: "قیمتیں",
        onRoadPrice: "سڑک پر قیمت",
        findUsedBikes: "استعمال شدہ بائک تلاش کریں",
        usedBikesListings: "استعمال شدہ بائک لسٹنگ",
        premiumBikes: "پریمیم بائک",
        sellBike: "اپنی بائک بیچیں",
        findNewBikes: "نئی بائک تلاش کریں",
        newBikesPrices: "نئی بائک کی قیمتیں",
        autofinderStore: "آٹوفائنڈر آٹو اسٹور",
        findAutoParts: "آٹو پارٹس تلاش کریں",
        sellCarParts: "کار کے پرزے بیچیں",
        dealerPackages: "ڈیلر پیکجز",
        faqs: "سوالات",
        videos: "ویڈیوز",
        forums: "فورمز",
        contactUs: "ہم سے رابطہ کریں",
        help: "مدد",
        aboutUs: "ہمارے بارے میں",
        privacyPolicy: "پرائیویسی پالیسی",
        compare: "موازنہ",
        carOnRent: "کرایہ پر کار",
        buyCarForMe: "میرے لیے کار خریدیں",
        profile: "پروفائل",
        myAds: "میرے اشتہارات",
        myPackages: "میرے پیکجز",
        logout: "لاگ آؤٹ",
        lightMode: "لائٹ موڈ",
        darkMode: "ڈارک موڈ",
        // Home Page
        heroTitle: "صحیح کار تلاش کریں",
        newCar: "نئی کار",
        usedCar: "استعمال شدہ کار",
        byBudget: "بجٹ کے مطابق",
        byModel: "ماڈل کے مطابق",
        priceRange: "قیمت کی حد",
        selectBudget: "بجٹ منتخب کریں",
        selectCity: "شہر منتخب کریں",
        selectModel: "ماڈل منتخب کریں",
        search: "تلاش کریں",
        advancedSearch: "جدید تلاش",
        sellCarDataTitle: "آٹو فائنڈر پر اپنی کار بیچیں اور بہترین قیمت حاصل کریں",
        sellItMyself: "خود بیچیں!",
        diySeller: "خود بیچنے والا • تیز",
        diyDesc: "اگر آپ مکمل کنٹرول اور فوری پوسٹنگ چاہتے ہیں تو بہترین ہے۔",
        postAdTime: "2 منٹ میں اشتہار لگائیں",
        userCount: "20 ملین صارفین",
        connectBuyers: "خریداروں سے براہ راست رابطہ کریں",
        postYourAd: "اپنا اشتہار لگائیں",
        carInspection: "کار انسپکشن",
        professionalService: "پیشہ ورانہ سروس",
        inspectionDesc: "ذہنی سکون کے لیے اپنی کار کا معائنہ تصدیق شدہ ماہرین سے کروائیں۔",
        expertInspection: "تصدیق شدہ ماہر معائنہ",
        report: "تفصیلی کنڈیشن رپورٹ",
        guarantee: "خریدار کے اعتماد کی ضمانت",
        // Footer
        footerAbout: "آٹو فائنڈر پاکستان کا سب سے بڑا آن لائن بازار ہے جہاں گاڑیاں خریدی اور بیچی جاتی ہیں۔ ہم خریداروں اور بیچنے والوں کو جوڑتے ہیں، جس سے گاڑیوں کا لین دین آسان، محفوظ اور باسہولت بنتا ہے۔ ہزاروں تصدیق شدہ گاڑیوں کی فہرستیں دیکھیں، قیمتوں کا موازنہ کریں، اور ہمارے جامع سرچ اور فلٹر آپشنز کے ساتھ اپنی پسندیدہ گاڑی تلاش کریں۔",
        usefulLinks: "مفید لنکس",
        latestCars: "تازہ ترین کاریں",
        upcomingCars: "آنے والی کاریں",
        searchUsedCar: "استعمال شدہ کار تلاش کریں",
        carSell: "کار بیچیں",
        compareCar: "کار کا موازنہ",
        recentPosts: "حالیہ پوسٹس",
        newsletter: "نیوز لیٹر",
        newsletterDesc: "ہماری ہمیشہ ارتقا پذیر مصنوعات کی خصوصیات اور ٹیکنالوجی سے باخبر رہیں۔ اپنا ای میل درج کریں اور ہمارے نیوز لیٹر کو سبسکرائب کریں۔",
        enterEmail: "اپنا ای میل درج کریں",
        subscribe: "سبسکرائب کریں",
        subscribing: "سبسکرائب ہو رہا ہے...",
        copyright: "© کاپی رائٹ 2025 تیار کردہ",
        phone: "فون :",
        email: "ای میل :",
        timeToChange: "تبدیلی کا وقت...",
        aboutUs: "ہمارے بارے میں",
        contactUs: "ہم سے رابطہ کریں",
        help: "مدد",
        privacyPolicy: "رازداری کی پالیسی",
        // Filters & Dropdowns
        from: "سے",
        to: "تک",
        go: "جائیں",
        lacs: "لاکھ",
        crore: "کروڑ",
        thousand: "ہزار",
        any: "کوئی بھی",
        all: "تمام",
        select: "منتخب کریں",
        // Common Filters
        make: "میک",
        model: "ماڈل",
        year: "سال",
        mileage: "مائلیج",
        condition: "حالت",
        transmission: "ٹرانسمیشن",
        fuelType: "ایندھن کی قسم",
        bodyType: "باڈی ٹائپ",
        engineCapacity: "انجن کی صلاحیت",
        registered: "رجسٹرڈ",
        assembly: "اسمبلی",
        // Actions
        filter: "فلٹر",
        sort: "ترتیب",
        reset: "دوبارہ سیٹ کریں",
        apply: "لاگو کریں",
        clear: "صاف کریں",
        viewDetails: "تفصیلات دیکھیں",
        viewMore: "مزید دیکھیں",
        loadMore: "مزید لوڈ کریں",
        // Car Details
        specifications: "تفصیلات",
        features: "خصوصیات",
        description: "تفصیل",
        contactSeller: "بیچنے والے سے رابطہ کریں",
        share: "شیئر کریں",
        report: "رپورٹ کریں",
        viewPhone: "فون نمبر دیکھیں",
        sendMessage: "پیغام بھیجیں",
        makeOffer: "پیشکش کریں",
        // Form Labels
        name: "نام",
        phone: "فون",
        message: "پیغام",
        address: "پتہ",
        submit: "جمع کرائیں",
        cancel: "منسوخ کریں",
        save: "محفوظ کریں",
        edit: "ترمیم کریں",
        delete: "حذف کریں",
        update: "اپ ڈیٹ کریں",
        upload: "اپ لوڈ کریں",
        // Auth
        password: "پاس ورڈ",
        confirmPassword: "پاس ورڈ کی تصدیق کریں",
        forgotPassword: "پاس ورڈ بھول گئے؟",
        rememberMe: "مجھے یاد رکھیں",
        dontHaveAccount: "اکاؤنٹ نہیں ہے؟",
        alreadyHaveAccount: "پہلے سے اکاؤنٹ ہے؟",
        // Car Specs
        color: "رنگ",
        doors: "دروازے",
        seats: "نشستیں",
        owner: "مالک",
        location: "مقام",
        postedOn: "پوسٹ کیا گیا",
        adId: "اشتہار آئی ڈی",
        // Sort Options
        sortBy: "ترتیب دیں",
        priceLowToHigh: "قیمت: کم سے زیادہ",
        priceHighToLow: "قیمت: زیادہ سے کم",
        newest: "تازہ ترین پہلے",
        oldest: "پرانے پہلے",
        mileageLowToHigh: "مائلیج: کم سے زیادہ",
        // Messages
        noCarsFound: "کوئی گاڑی نہیں ملی",
        noResultsFound: "کوئی نتیجہ نہیں ملا",
        loading: "لوڈ ہو رہا ہے...",
        tryAdjustingFilters: "اپنے فلٹرز کو ایڈجسٹ کرنے کی کوشش کریں",
        // Pagination
        previous: "پچھلا",
        next: "اگلا",
        page: "صفحہ",
        of: "کا",
        showing: "دکھا رہے ہیں",
        results: "نتائج",
        // YouTube Section
        shortsAndVideos: "شارٹس اور ویڈیوز",
        // News Section
        latestNews: "تازہ ترین خبریں",
        readMore: "مزید پڑھیں",
        // Car Listing & Details
        featured: "فیچرڈ",
        managedBy: "زیرِ انتظام",
        viewAllCars: "تمام گاڑیاں دیکھیں",
        noBidsYet: "ابھی تک کوئی بولی نہیں",
        highestBid: "سب سے زیادہ بولی",
        placeBid: "بولی لگائیں",
        buyNow: "ابھی خریدیں",
        // Sidebar Filters - Headers
        filters: "فلٹرز",
        byCity: "شہر کے لحاظ سے",
        byProvince: "صوبے کے لحاظ سے",
        byMake: "میک کے لحاظ سے",
        byModel: "ماڈل کے لحاظ سے",
        byYear: "سال کے لحاظ سے",
        byPrice: "قیمت کے لحاظ سے",
        byMileage: "مائلیج کے لحاظ سے",
        byBodyType: "باڈی ٹائپ کے لحاظ سے",
        byFuelType: "ایندھن کی قسم کے لحاظ سے",
        byTransmission: "ٹرانسمیشن کے لحاظ سے",
        byColor: "رنگ کے لحاظ سے",
        byAssembly: "اسمبلی کے لحاظ سے",
        // Provinces
        punjab: "پنجاب",
        sindh: "سندھ",
        kpk: "خیبر پختونخوا",
        balochistan: "بلوچستان",
        islamabadCapital: "اسلام آباد",
        azadKashmir: "آزاد کشمیر",
        // Transmission Types
        automatic: "آٹومیٹک",
        manual: "مینوئل",
        // Fuel Types
        petrol: "پیٹرول",
        diesel: "ڈیزل",
        hybrid: "ہائبرڈ",
        electric: "الیکٹرک",
        cng: "سی این جی",
        lpg: "ایل پی جی",
        // Body Types
        sedan: "سیڈان",
        hatchback: "ہیچ بیک",
        suv: "ایس یو وی",
        crossover: "کراس اوور",
        coupe: "کوپے",
        convertible: "کنورٹیبل",
        wagon: "ویگن",
        van: "وین",
        minivan: "منی وین",
        pickup: "پک اپ",
        truck: "ٹرک",
        // Assembly Types
        local: "لوکل",
        imported: "امپورٹڈ",
        // Colors
        white: "سفید",
        black: "کالا",
        silver: "چاندی",
        grey: "سرمئی",
        gray: "سرمئی",
        red: "سرخ",
        blue: "نیلا",
        green: "سبز",
        brown: "بھورا",
        gold: "سنہری",
        unlisted: "غیر فہرست شدہ",
        // Car Specifications
        kmDriven: "کلومیٹر چلائے",
        km: "کلومیٹر",
        cc: "سی سی",
        registeredIn: "رجسٹرڈ ان",
        trustedCars: "قابل اعتماد گاڑیاں",
        inspected: "معائنہ شدہ",
        certified: "تصدیق شدہ",
        numberOfDoors: "دروازوں کی تعداد",
        seatingCapacity: "بیٹھنے کی گنجائش",
        // Sell Car Page
        carInformation: "گاڑی کی معلومات",
        uploadPhotos: "تصاویر اپ لوڈ کریں",
        contactInformation: "رابطے کی معلومات",
        selectMake: "میک منتخب کریں",
        selectModel: "ماڈل منتخب کریں",
        selectYear: "سال منتخب کریں",
        enterPrice: "قیمت درج کریں",
        enterMileage: "مائلیج درج کریں",
        selectColor: "رنگ منتخب کریں",
        selectTransmission: "ٹرانسمیشن منتخب کریں",
        selectFuelType: "ایندھن کی قسم منتخب کریں",
        selectBodyType: "باڈی ٹائپ منتخب کریں",
        selectAssembly: "اسمبلی منتخب کریں",
        enterEngineCapacity: "انجن کی صلاحیت درج کریں",
        selectRegisteredCity: "رجسٹرڈ شہر منتخب کریں",
        adTitle: "اشتہار کا عنوان",
        adDescription: "اشتہار کی تفصیل",
        // Profile & My Ads
        myProfile: "میری پروفائل",
        editProfile: "پروفائل میں ترمیم کریں",
        changePassword: "پاس ورڈ تبدیل کریں",
        myFavorites: "میری پسندیدہ",
        savedSearches: "محفوظ شدہ تلاشیں",
        active: "فعال",
        inactive: "غیر فعال",
        pending: "زیر التواء",
        approved: "منظور شدہ",
        rejected: "مسترد",
        expired: "میعاد ختم",
        sold: "فروخت ہو گئی",
        // Time & Date
        today: "آج",
        yesterday: "کل",
        daysAgo: "دن پہلے",
        weeksAgo: "ہفتے پہلے",
        monthsAgo: "ماہ پہلے",
        yearsAgo: "سال پہلے",
        // Common Phrases
        viewAll: "تمام دیکھیں",
        seeMore: "مزید دیکھیں",
        seeLess: "کم دیکھیں",
        showMore: "مزید دکھائیں",
        showLess: "کم دکھائیں",
        backToTop: "اوپر واپس جائیں",
        goBack: "واپس جائیں",
        continue: "جاری رکھیں",
        confirm: "تصدیق کریں",
        yes: "ہاں",
        no: "نہیں",
        ok: "ٹھیک ہے",
        close: "بند کریں",
        // Error & Success Messages
        error: "خرابی",
        success: "کامیابی",
        warning: "انتباہ",
        info: "معلومات",
        pleaseWait: "براہ کرم انتظار کریں...",
        processingRequest: "آپ کی درخواست پر کارروائی ہو رہی ہے...",
        somethingWentWrong: "کچھ غلط ہو گیا",
        tryAgain: "دوبارہ کوشش کریں",
        required: "ضروری",
        optional: "اختیاری",
        invalidEmail: "غلط ای میل ایڈریس",
        invalidPhone: "غلط فون نمبر",
        passwordTooShort: "پاس ورڈ بہت چھوٹا ہے",
        passwordsDoNotMatch: "پاس ورڈ مماثل نہیں ہیں",
        // Auth Messages
        welcomeBack: "خوش آمدید",
        signInToAccount: "اپنے آٹوفائنڈر اکاؤنٹ میں سائن ان کریں",
        emailOrPhone: "ای میل یا فون",
        enterEmailOrPhone: "اپنا ای میل یا فون درج کریں",
        enterPassword: "اپنا پاس ورڈ درج کریں",
        signingIn: "سائن ان ہو رہا ہے...",
        pleaseEnterEmailAndPassword: "براہ کرم ای میل/فون اور پاس ورڈ درج کریں",
        loginSuccessful: "لاگ ان کامیاب!",
        loginFailedCheckCredentials: "لاگ ان ناکام۔ براہ کرم اپنی معلومات چیک کریں۔",
        errorDuringLogin: "لاگ ان کے دوران خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔",
        createAccount: "اکاؤنٹ بنائیں",
        signUpToGetStarted: "آٹوفائنڈر کے ساتھ شروع کرنے کے لیے سائن اپ کریں",
        fullName: "پورا نام",
        enterFullName: "اپنا پورا نام درج کریں",
        emailAddress: "ای میل ایڈریس",
        enterEmail: "اپنا ای میل درج کریں",
        phoneNumber: "فون نمبر",
        enterPhoneNumber: "اپنا فون نمبر درج کریں",
        enterPasswordMinChars: "اپنا پاس ورڈ درج کریں (کم از کم 8 حروف)",
        confirmYourPassword: "اپنے پاس ورڈ کی تصدیق کریں",
        creatingAccount: "اکاؤنٹ بنایا جا رہا ہے...",
        clickToUploadProfile: "پروفائل تصویر اپ لوڈ کرنے کے لیے کلک کریں (اختیاری)",
        passwordMustBe8Chars: "پاس ورڈ کم از کم 8 حروف کا ہونا ضروری ہے",
        imageSizeLessThan5MB: "تصویر کا سائز 5MB سے کم ہونا چاہیے",
        pleaseFillAllFields: "براہ کرم تمام ضروری فیلڈز بھریں",
        passwordMustBe8CharsLong: "پاس ورڈ کم از کم 8 حروف لمبا ہونا چاہیے",
        pleaseEnterValidEmail: "براہ کرم درست ای میل ایڈریس درج کریں",
        accountCreatedSuccessfully: "اکاؤنٹ کامیابی سے بن گیا! جاری رکھنے کے لیے براہ کرم لاگ ان کریں۔",
        signupFailed: "سائن اپ ناکام۔ براہ کرم دوبارہ کوشش کریں۔",
        errorDuringSignup: "سائن اپ کے دوران خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔",
        dontHaveAccount: "اکاؤنٹ نہیں ہے؟",
        alreadyHaveAccount: "پہلے سے اکاؤنٹ ہے؟",
        forgotPassword: "پاس ورڈ بھول گئے؟",
        confirmPassword: "پاس ورڈ کی تصدیق کریں",
        // Used Cars & Filters
        usedCars: "استعمال شدہ گاڑیاں",
        findUsedCars: "استعمال شدہ گاڑیاں تلاش کریں",
        allCars: "تمام گاڑیاں",
        allPrices: "تمام قیمتیں",
        allYears: "تمام سال",
        allMileage: "تمام مائلیج",
        allColors: "تمام رنگ",
        sortBy: "ترتیب دیں",
        priceHighToLow: "قیمت: زیادہ سے کم",
        priceLowToHigh: "قیمت: کم سے زیادہ",
        yearNewestFirst: "سال: نیا پہلے",
        yearOldestFirst: "سال: پرانا پہلے",
        mileageLowToHigh: "مائلیج: کم سے زیادہ",
        mileageHighToLow: "مائلیج: زیادہ سے کم",
        results: "نتائج",
        carsFound: "گاڑیاں ملیں",
        noCarsFound: "کوئی گاڑی نہیں ملی",
        clearFilters: "فلٹرز صاف کریں",
        applyFilters: "فلٹرز لگائیں",
        // Car Detail
        carDetails: "گاڑی کی تفصیلات",
        specifications: "تفصیلات",
        features: "خصوصیات",
        description: "تفصیل",
        sellerInfo: "فروخت کنندہ کی معلومات",
        contactSeller: "فروخت کنندہ سے رابطہ کریں",
        makeOffer: "پیشکش کریں",
        reportAd: "اشتہار کی اطلاع دیں",
        shareAd: "اشتہار شیئر کریں",
        similarCars: "ملتی جلتی گاڑیاں",
        // Sell Car
        sellYourCar: "اپنی گاڑی فروخت کریں",
        postYourAd: "اپنا اشتہار پوسٹ کریں",
        adPostedSuccessfully: "اشتہار کامیابی سے پوسٹ ہو گیا!",
        fillAllRequiredFields: "براہ کرم تمام ضروری فیلڈز بھریں",
        // Profile & Dashboard
        dashboard: "ڈیش بورڈ",
        myAccount: "میرا اکاؤنٹ",
        accountSettings: "اکاؤنٹ کی ترتیبات",
        notifications: "اطلاعات",
        messages: "پیغامات",
        logout: "لاگ آؤٹ",
        // Services
        ourServices: "ہماری خدمات",
        carInspection: "گاڑی کا معائنہ",
        bookInspection: "معائنہ بک کریں",
        inspectionBooked: "معائنہ کامیابی سے بک ہو گیا!",
        // Contact
        contactUs: "ہم سے رابطہ کریں",
        getInTouch: "رابطے میں رہیں",
        sendMessage: "پیغام بھیجیں",
        yourMessage: "آپ کا پیغام",
        messageSent: "پیغام کامیابی سے بھیج دیا گیا!",
        // Common Actions
        viewDetails: "تفصیلات دیکھیں",
        loadMore: "مزید لوڈ کریں",
        refresh: "تازہ کریں",
        download: "ڈاؤن لوڈ کریں",
        share: "شیئر کریں",
        copy: "کاپی کریں",
        copied: "کاپی ہو گیا!",
        // Status
        loading: "لوڈ ہو رہا ہے...",
        noData: "کوئی ڈیٹا دستیاب نہیں",
        comingSoon: "جلد آ رہا ہے",
        new: "نیا",
        premium: "پریمیم",
        // Section Headings
        browseUsedCars: "استعمال شدہ گاڑیاں تلاش کریں",
        forYourQuickLook: "آپ کی فوری نظر کے لیے",
        autofinderServices: "آٹو فائنڈر خدمات",
        premiumSolutions: "ہر گاڑی کے مالک کے لیے پریمیم حل",
        // Filter Tabs
        category: "زمرہ",
        city: "شہر",
        make: "بنانے والا",
        model: "ماڈل",
        budget: "بجٹ",
        bodyType: "باڈی ٹائپ",
        // Tab Buttons
        managedByAutofinder: "آٹو فائنڈر کے زیر انتظام",
        popularNewCars: "مقبول نئی گاڑیاں",
        premiumCars: "پریمیم گاڑیاں",
        premiumBikes: "پریمیم بائیکس",
        rentCar: "کرائے کی گاڑی",
        autoStore: "آٹو سٹور",
        // Service Cards
        freeAd: "مفت اشتہار",
        premiumAd: "پریمیم اشتہار",
        buyForMe: "میرے لیے خریدیں",
        listForYou: "آپ کے لیے فہرست بنائیں",
        inspection: "معائنہ",
        carOnRent: "کرائے پر گاڑی",
        exploreMore: "مزید دریافت کریں",
        // Service Descriptions
        freeAdDesc: "اپنی گاڑی کو بہترین قیمت پر فروخت کرنے کا آسان ترین طریقہ۔",
        premiumAdDesc: "نمایاں فہرستوں کے ساتھ اپنی گاڑی کی مرئیت بڑھائیں۔ ہمارے پریمیم اشتہارات آپ کو عام اشتہارات سے 5 گنا تیزی سے فروخت کرنے میں مدد کرتے ہیں۔",
        buyForMeDesc: "ہمارے ماہر مشیروں کو اپنی ضروریات کی بنیاد پر آپ کے لیے بہترین گاڑی تلاش کرنے، معائنہ کرنے اور گفت و شنید کرنے دیں۔",
        listForYouDesc: "آرام کریں جبکہ ہم آپ کی گاڑی فروخت کرتے ہیں۔ پیشہ ورانہ فوٹوگرافی سے لے کر ڈیل بند کرنے تک، ہم سب کچھ منظم کرتے ہیں۔",
        inspectionDesc: "اپنے گھر کے آرام میں تفصیلی گاڑی کا معائنہ رپورٹ حاصل کریں۔ اعتماد کے ساتھ خریدیں۔",
        carOnRentDesc: "لچکدار مختصر اور طویل مدتی کرایہ کے اختیارات کے لیے دستیاب پریمیم گاڑیوں کی وسیع رینج میں سے انتخاب کریں۔",
        // Error Messages
        unableToLoad: "لوڈ کرنے میں ناکام",
        errorFailedToFetch: "خرابی: حاصل کرنے میں ناکام",
        retry: "دوبارہ کوشش کریں",
        tryAnotherFilter: "دوسرا فلٹر آزمائیں",
        noCarsAvailable: "کوئی گاڑیاں دستیاب نہیں",
        tryAnotherFilter: "دوسرا فلٹر آزمائیں",
        // Car Detail
        loadingCarDetails: "گاڑی کی تفصیلات لوڈ ہو رہی ہیں",
        carNotFound: "گاڑی نہیں ملی",
        carNotFoundDesc: "وہ گاڑی جس کی آپ تلاش کر رہے ہیں وہ موجود نہیں ہے۔",
        browseNewCars: "نئی گاڑیاں دیکھیں",
        goBack: "واپس جائیں",
        featured: "نمایاں",
        transmission: "ٹرانسمیشن",
        engine: "انجن",
        fuelType: "ایندھن کی قسم",
        color: "رنگ",
        seats: "نشستیں",
        driveType: "ڈرائیو کی قسم",
        contactDealer: "ڈیلر سے رابطہ کریں",
        overview: "جائزہ",
        specifications: "تفصیلات",
        pictures: "تصاویر",
        carOverview: "گاڑی کا جائزہ",
        engineCapacity: "انجن کی گنجائش",
        loadingUsedCarDetails: "استعمال شدہ گاڑی کی تفصیلات لوڈ ہو رہی ہیں",
        browseUsedCars: "استعمال شدہ گاڑیاں دیکھیں",
        managedByAutofinder: "آٹو فائنڈر کے زیر انتظام",
        premium: "پریمیم",
        freeAd: "مفت اشتہار",
        carDescription: "گاڑی کی تفصیل",
        additionalDetails: "مزید تفصیلات",
        registrationCity: "رجسٹریشن کا شہر",
        condition: "حالت",
        contactSeller: "فروخت کنندہ سے رابطہ کریں",
        mileage: "مائلیج",
        selectCity: "شہر منتخب کریں",
        searchCity: "شہر تلاش کریں...",
        noCityFound: "کوئی شہر نہیں ملا",
        selectMake: "کمپنی منتخب کریں",
        searchMake: "کمپنی تلاش کریں...",
        noMakeFound: "کوئی کمپنی نہیں ملی",
        selectModel: "ماڈل منتخب کریں",
        selectMakeFirst: "پہلے کمپنی منتخب کریں",
        searchModel: "ماڈل تلاش کریں...",
        noModelFound: "کوئی ماڈل نہیں ملا",
        selectVariant: "ویرینٹ منتخب کریں",
        selectMakeAndModelFirst: "پہلے کمپنی اور ماڈل منتخب کریں",
        searchVariant: "ویرینٹ تلاش کریں...",
        noVariantFound: "کوئی ویرینٹ نہیں ملا",
        postAnAd: "اشتہار لگائیں",
        selectPackage: "پیکیج منتخب کریں",
        validity: "میعاد",
        kmDriven: "کلومیٹر چلے ہوئے",
        preferredContact: "رابطہ کا ترجیحی طریقہ",
        mobile: "موبائل",
        featuredAds: "نمایاں اشتہارات",
        freeAds: "مفت اشتہارات",
        price: "قیمت",
        location: "مقام",
        description: "تفصیل",
        bodyColor: "گاڑی کا رنگ",
        postAdTime: "صرف 2 منٹ میں اپنا اشتہار لگائیں",
        chooseService: "سروس منتخب کریں",
        freeAdService: "مفت اشتہار",
        premiumAdService: "پریمیم اشتہار",
        listItService: "ہمارے ذریعے اشتہار لگائیں",
        sellFaster: "تیزی سے فروخت کریں",
        allFeatures: "تمام خصوصیات",
        select: "منتخب کریں",
        next: "اگلا",
        back: "پیچھے",
        finish: "تکمیل",
        step: "مرحلہ",
        adDetails: "اشتہار کی تفصیلات",
        contactDetails: "رابطہ کی تفصیلات",
        uploadPhotos: "تصاویر اپلوڈ کریں",
        transmissionLabel: "ٹرانسمیشن",
        fuelTypeLabel: "ایندھن کی قسم",
        bodyTypeLabel: "باڈی ٹائپ",
        engineCapacityLabel: "انجن کی گنجائش",
        assemblyLabel: "اسمبلی",
        doorsLabel: "دروازے",
        yearLabel: "سال",
        makeLabel: "کمپنی",
        modelLabel: "ماڈل",
        variantLabel: "ویرینٹ",
        selectYear: "سال منتخب کریں",
        days: "دن",
        selectFuelType: "ایندھن کی قسم منتخب کریں",
        selectTransmission: "ٹرانسمیشن منتخب کریں",
        selectBodyType: "باڈی ٹائپ منتخب کریں",
        selectAssembly: "اسمبلی منتخب کریں",
        selectColor: "رنگ منتخب کریں",
        petrol: "پیٹرول",
        diesel: "ڈیزل",
        hybrid: "ہائبرڈ",
        electric: "الیکٹرک",
        cng: "سی این جی",
        lpg: "ایل پی جی",
        automatic: "آٹومیٹک",
        manual: "مینول",
        descriptionLabel: "تفصیل",
        featuresLabel: "خصوصیات",
        imagesLabel: "تصاویر",
        upTo20Images: "(زیادہ سے زیادہ 20 تصاویر)",
        max10Images: "(زیادہ سے زیادہ 10 تصاویر)",
        airconditioning: "ایئر کنڈیشننگ",
        abs: "اے بی ایس",
        airbags: "ایئر بیگز",
        sunroof: "سن روف",
        bluetooth: "بلوٹوتھ",
        cruisecontrol: "کروز کنٹرول",
        parkingsensors: "پارکنگ سینسرز",
        navigation: "نیویگیشن",
        leatherseats: "چمڑے کی نشستیں",
        heatedseats: "گرم نشستیں",
        rearcamera: "بیک کیمرہ",
        keylessentry: "بغیر چابی کے انٹری",
        alloywheels: "الائے وہیل",
        foglights: "فوگ لائٹس",
        touchscreen: "ٹچ اسکرین",
        powersteering: "پاور اسٹیئرنگ",
        powerwindows: "پاور ونڈوز",
        selectPremiumPackage: "پریمیم پیکیج منتخب کریں",
        loadingPackages: "پیکیجز لوڈ ہو رہے ہیں...",
        noPackagesAvailable: "اس وقت کوئی پیکیج دستیاب نہیں ہے۔",
        popular: "مشہور",
        youSave: "آپ کی بچت:",
        validity: "میعاد:",
        totalAds: "کل اشتہارات:",
        freeBoosters: "مفت بوسٹرز:",
        selectPackage: "پیکیج منتخب کریں",
        createPremiumAd: "پریمیم کار اشتہار بنائیں",
        selectedPackageLabel: "منتخب پیکیج:",
        titleLabel: "عنوان",
        pricePkr: "قیمت (PKR)",
        kmDrivenLabel: "کل کلومیٹر",
        mileageLabel: "مائلیج",
        paymentInvoiceOptional: "ادائیگی کی رسید کی تصویر (اختیاری)",
        postFreeAdBtn: "مفت اشتہار لگائیں",
        creatingAd: "اشتہار بنایا جا رہا ہے...",
        titlePlaceholder: "مثلاً ٹوٹوٹا کرولا 2020",
        pricePlaceholder: "مثلاً 2500000",
        kmPlaceholder: "مثلاً 50000",
        capacityPlaceholder: "مثلاً 1800",
        descriptionPlaceholder: "اپنی گاڑی کی تفصیل بیان کریں...",
        cancel: "منسوخ کریں",
        createFreeAd: "مفت کار اشتہار بنائیں",
        freeAdLimitCompleted: "مفت اشتہار کی حد ختم ہوگئی",
        freeAdLimitDesc: "آپ نے اپنے تمام مفت اشتہارات استعمال کر لیے ہیں۔ جاری رکھنے کے لیے نیچے دیا گیا فارم پُر کریں اور 525 روپے کی ادائیگی کی رسید اپ لوڈ کریں۔",
        freeAdLimitNote: "نوٹ: 2 مفت اشتہارات کے بعد، ہر اضافی اشتہار کی قیمت 525 روپے ہوگی۔ یہ رقم بعد میں آپ کی خریدی گئی کسی بھی پریمیم سروس سے ایڈجسٹ کر دی جائے گی۔",
        standardAdPackage: "سٹینڈرڈ اشتہار پیکیج",
        standardAdDesc: "معیاری ویوز کے ساتھ اپنی کار کی فہرست بنائیں",
        standardVisibility: "معیاری لسٹنگ ویوز",
        activeAfterVerification: "ادائیگی کی تصدیق کے بعد اشتہار فعال ہو جائے گا",
        amountAdjustable: "رقم پریمیم سروسز سے ایڈجسٹ کی جا سکتی ہے",
        paymentDetails: "ادائیگی کی تفصیلات",
        easypaisaJazzcash: "ایزی پیسہ | جیز کیش",
        accountNumber: "اکاؤنٹ نمبر",
        accountName: "اکاؤنٹ کا نام",
        copy: "کاپی کریں",
        paymentReceipt: "ادائیگی کی رسید",
        uploadReceiptDesc: "525 روپے کی ادائیگی کی رسید اپ لوڈ کریں۔ ایڈمن کی تصدیق کے بعد اشتہار فعال ہو جائے گا۔",
        carDetails: "کار کی تفصیلات",
        backToAllServices: "← تمام سروسز پر واپس جائیں",
        autofinderServices: "آٹو فائنڈر سروسز",
        sellYourCarFree: "اپنی گاڑی مفت فروخت کریں",
        premiumCarAd: "پریمیم کار اشتہار",
        freeAdDesc: "منٹوں میں اپنا اشتہار بنائیں۔ 20+ ملین کے قابل اعتماد کمیونٹی تک رسائی حاصل کریں۔ خریداروں سے براہ راست رابطہ کریں۔",
        premiumAdDesc: "نمایاں فہرست کے ساتھ پریمیم ویوز حاصل کریں۔ آپ کا اشتہار نمایاں کیا جائے گا اور زیادہ خریداروں کو دکھایا جائے گا۔",
        or: "یا",
        Weston: "Weston",
        // Final Sweep Keys
        aboutUsTitle: "ہمارے بارے میں",
        aboutDesc1: "آٹو فائنڈر ایک مکمل آٹوموٹو پلیٹ فارم ہے جو گاڑیوں کی خرید، فروخت، کرایہ اور معائنے کو آسان، تیز اور قابل اعتماد بنانے کے لیے ڈیزائن کیا گیا ہے۔",
        aboutDesc2: "ہمارا مقصد صارفین کو ایک ہی جگہ پر پیشہ ورانہ خدمات فراہم کر کے گاڑیوں کا شفاف اور پریشانی سے پاک تجربہ فراہم کرنا ہے۔ چاہے آپ اپنی خوابوں کی گاڑی خریدنا چاہتے ہوں، اپنی موجودہ گاڑی فروخت کرنا چاہتے ہوں، کسی خاص موقع کے لیے گاڑی کرائے پر لینا چاہتے ہوں، یا گاڑی کا پیشہ ورانہ معائنہ کروانا چاہتے ہوں، آٹو فائنڈر آپ کی مدد کے لیے حاضر ہے۔",
        aboutDesc3: "شفافیت، قابل اعتماد اور صارفین کی اطمینان کے لیے ہماری وابستگی ہمیں دوسروں سے ممتاز بناتی ہے۔ ہمارا ماننا ہے کہ ہر کوئی ایک ہموار اور تناؤ سے پاک آٹوموٹو تجربے کا حقدار ہے، اور ہم اسے اپنے تمام صارفین کے لیے حقیقت بنانے کے لیے وقف ہیں۔",
        haveAnyQuestion: "کوئی سوال ہے؟",
        areYouLookingToBuyACar: "کیا آپ گاڑی خریدنا چاہتے ہیں؟",
        ctaDesc1: "اپنی پسند کی گاڑی",
        ctaDesc2: "سے زیادہ آپشنز میں سے تلاش کریں۔ بہترین قیمت، تصدیق شدہ فروخت کنندگان اور 24/7 سپورٹ۔",
        searchYourCar: "اپنی گاڑی تلاش کریں",
        moreChoices: "مزید انتخاب...",
        byCity: "شہر کے لحاظ سے",
        byPrice: "بجٹ کے لحاظ سے",
        loadingStats: "اعداد و شمار لوڈ ہو رہے ہیں...",
        thousandsOf: "ہزاروں",
        options: "آپشنز",
        province: "صوبہ",
        registeredIn: "رجسٹرڈ شدہ",
        trustedCars: "بھروسہ مند گاڑیاں",
        engineType: "انجن کی قسم",
        assembly: "اسمبلی",
        doors: "دروازے",
        seatingCapacity: "بیٹھنے کی گنجائش",
        resetAll: "سب دوبارہ سیٹ کریں",
        showing: "دکھایا جا رہا ہے",
        carBadge: "گاڑی",
        carsBadge: "گاڑیاں",
        filtered: "فلٹر شدہ",
        loadingUsedCars: "استعمال شدہ گاڑیاں لوڈ ہو رہی ہیں...",
        unableToLoadUsedCars: "استعمال شدہ گاڑیاں لوڈ کرنے میں ناکام",
        noUsedCarsFound: "کوئی استعمال شدہ گاڑیاں نہیں ملیں",
        trySelectingDifferentFilters: "مختلف فلٹرز منتخب کرنے کی کوشش کریں",
        managed: "منظم",
        premium: "پریمیم",
        freeAdBadge: "مفت اشتہار",
        yearLabelField: "سال:",
        transLabelField: "ٹرانس:",
        engineLabelField: "انجن:",
        mileageLabelField: "مائلیج:",
        priceOnCall: "قیمت کال پر",
        sorryNoCarsFor: "معذرت، کے لیے کوئی گاڑیاں دستیاب نہیں ہیں",
        inKeyword: "میں",
        atTheMoment: "اس وقت۔",
        subscribeSuccess: "نیوز لیٹر کے لیے کامیابی کے ساتھ سبسکرائب کر لیا گیا!",
        subscribeFailed: "سبسکرپشن میں ناکامی ہوئی۔ براہ کرم دوبارہ کوشش کریں۔",
        validEmailError: "براہ کرم ایک درست ای میل ایڈریس درج کریں",
        emailRequiredError: "براہ کرم اپنا ای میل ایڈریس درج کریں",
        thankYouSubscribe: "سبسکرائب کرنے کا شکریہ!",
        by: "بذریعہ",
        viewDetails: "تفصیلات دیکھیں",
        new: "نیا",
        showResultsBy: "نتائج دکھائیں بذریعہ",
        clearFilters: "فلٹرز صاف کریں",
        go: "شروع کریں",
        searchByMakeModelCity: "مثال: لاہور میں ہونڈا",
        pkr: "روپیہ",
        // Profile Page
        myProfile: "میری پروفائل",
        backToDashboard: "واپس ڈیش بورڈ پر",
        editProfile: "پروفائل تبدیل کریں",
        saveChanges: "تبدیلیاں محفوظ کریں",
        gender: "جنس",
        male: "مرد",
        female: "خواتین",
        other: "دیگر",
        dateOfBirth: "تاریخ پیدائش",
        country: "ملک",
        city: "شہر",
        username: "صارف کا نام",
        email: "ای میل",
        verified: "تصدیق شدہ",
        notVerified: "غیر تصدیق شدہ",
        addNumber: "نمبر درج کریں",
        verifyEmail: "ای میل کی تصدیق کریں",
        emailVerificationDesc: "آپ نے اپنے ای میل پتے کی تصدیق نہیں کی ہے۔ آپ تصدیقی ای میل دوبارہ بھیج سکتے ہیں",
        clickingHere: "یہاں کلک کر کے",
        resendVerificationEmail: "تصدیقی ای میل دوبارہ بھیجیں",
        sending: "بھیجا جا رہا ہے...",
        otpSent: "او ٹی پی آپ کے ای میل پر بھیج دیا گیا ہے! براہ کرم اپنا ان باکس چیک کریں۔",
        enterOtp: "او ٹی پی درج کریں",
        verifyOtp: "او ٹی پی کی تصدیق کریں",
        resend: "دوبارہ بھیجیں",
        otpVerification: "او ٹی پی کی تصدیق",
        otpVerificationDesc: "ہم نے آپ کے ای میل پر 6 ہندسوں کا او ٹی پی بھیجا ہے۔ براہ کرم ای میل کی تصدیق کے لیے اسے نیچے درج کریں۔",
        profileUpdated: "پروفائل کامیابی کے ساتھ اپ ڈیٹ ہو گئی!",
        noChangesDetected: "کوئی تبدیلی نہیں ملی۔ براہ کرم محفوظ کرنے سے پہلے کم از کم ایک فیلڈ میں تبدیلی کریں۔",
        imageSizeLimit: "تصویر کا سائز 5 ایم بی سے کم ہونا چاہیے",
        maxSize: "زیادہ سے زیادہ سائز:",
        selectGender: "جنس منتخب کریں",
        selectCountry: "ملک منتخب کریں",
        selectCity: "شہر منتخب کریں",
        // My Ads
        myAds: "میرے اشتہارات",
        activeAds: "فعال اشتہارات",
        pendingAds: "زیر التواء اشتہارات",
        rejectedAds: "مسترد شدہ اشتہارات",
        noAdsFound: "کوئی اشتہار نہیں ملا",
        manageAds: "اشتہارات کا انتظام",
        editAd: "اشتہار تبدیل کریں",
        deleteAd: "اشتہار حذف کریں",
        boostAd: "اشتہار کو فروغ دیں",
        status: "حالت",
        views: "مناظر",
        postNewAd: "نیا اشتہار لگائیں",
        postYourFirstAd: "اپنا پہلا اشتہار لگائیں",
        allAdsCount: "کل ({{count}})",
        activeAdsCount: "فعال ({{count}})",
        pendingAdsCount: "زیر التواء ({{count}})",
        inactiveAdsCount: "غیر فعال ({{count}})",
        noAdsDescription: "آپ نے ابھی تک کوئی اشتہار نہیں لگایا ہے۔",
        noFilteredAdsDescription: "آپ کے پاس کوئی {{filter}} اشتہارات نہیں ہیں۔",
        untitledAd: "بغیر عنوان کا اشتہار",
        posted: "شائع شدہ",
        deleteConfirm: "کیا آپ واقعی اس اشتہار کو حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں لیا جا سکتا۔",
        adDeletedSuccess: "اشتہار کامیابی کے ساتھ حذف ہو گیا",
        adDeleteFailed: "اشتہار حذف کرنے میں ناکامی",
        // Edit Ad
        editAdTitle: "اشتہار تبدیل کریں",
        saving: "محفوظ ہو رہا ہے...",
        adUpdatedSuccess: "اشتہار کامیابی کے ساتھ اپ ڈیٹ ہو گیا!",
        adUpdateFailed: "اشتہار اپ ڈیٹ کرنے میں ناکامی",
        selectMakeFirst: "پہلے کمپنی منتخب کریں",
        selectMakeModelFirst: "پہلے کمپنی اور ماڈل منتخب کریں",
        searchCity: "شہر تلاش کریں...",
        noCityFound: "کوئی شہر نہیں ملا",
        searchMake: "کمپنی تلاش کریں...",
        noMakeFound: "کوئی کمپنی نہیں ملی",
        searchModel: "ماڈل تلاش کریں...",
        noModelFound: "کوئی ماڈل نہیں ملا",
        searchVariant: "ورینٹ تلاش کریں...",
        noVariantFound: "کوئی ورینٹ نہیں ملا",
        updateAd: "اشتہار اپ ڈیٹ کریں",
        maxImagesAllowed: "زیادہ سے زیادہ 10 تصاویر کی اجازت ہے",
        fillRequiredFields: "براہ کرم تمام مطلوبہ فیلڈز پر کریں",
        uploadAtLeastOneImage: "براہ کرم کم از کم ایک تصویر اپ لوڈ کریں",
        loginToEditAd: "اپنا اشتہار ایڈٹ کرنے کے لیے لاگ ان کریں",
        adNotFound: "اشتہار نہیں ملا۔ ہو سکتا ہے اسے حذف کر دیا گیا ہو یا آئی ڈی غلط ہو۔",
        // Ad Types
        featuredCar: "نمایاں کار",
        listItForYouBadge: "ہمارے ذریعے لگوائیں",
        freeAdBadgeShort: "مفت اشتہار",
        autoPartsBadge: "آٹو پارٹس",
        newCarBadge: "نئی کار",
        newBikeBadge: "نئی بائیک",
        rentCarBadge: "کرائے کی کار",
        premiumBikeBadge: "پریمیم بائیک",
        // Cities
        karachi: "کراچی",
        lahore: "لاہور",
        islamabad: "اسلام آباد",
        rawalpindi: "راولپنڈی",
        faisalabad: "فیصل آباد",
        multan: "ملتان",
        peshawar: "پشاور",
        quetta: "کوئٹہ",
        sialkot: "سیالکوٹ",
        gujranwala: "گوجرانوالہ",
        hyderabad: "حیدرآباد",
        sargodha: "سرگودھا",
        bahawalpur: "بہاولپور",
        sukkur: "سکھر",
        // Car Makes
        toyota: "ٹویوٹا",
        honda: "ہونڈا",
        suzuki: "سوزوکی",
        kia: "کیا",
        hyundai: "ہنڈائی",
        changan: "چنگان",
        mg: "ایم جی",
        proton: "پروٹون",
        haval: "ہاویل",
        prince: "پرنس",
        dfsks: "ڈی ایف ایس کے",
        faw: "فاؤ",
        united: "یونائیٹڈ",
        mercedes: "مرسڈیز",
        bmw: "بی ایم ڈبلیو",
        audi: "آڈی",
        lexus: "لیکسس",
        nissan: "نسان",
        mitsubishi: "مٹسوبشی",
        mazda: "مزدا",
        daihatsu: "ڈائیہاٹسو",
        // Car Features
        abs: "اے بی ایس",
        airconditioning: "ایئر کنڈیشنگ",
        alloyrims: "الائے رمز",
        amfmradio: "اے ایم/ایف ایم ریڈیو",
        cassetteplayer: "کیسٹ پلیئر",
        cdplayer: "سی ڈی پلیئر",
        dvdplayer: "ڈی وی ڈی پلیئر",
        immobilizerkey: "ایموبلائزر کی",
        keylessentry: "بغیر چابی کے انٹری",
        navigationsystem: "نیویگیشن سسٹم",
        powerlocks: "پاور لاکس",
        powermirrors: "پاور مررز",
        powersteering: "پاور اسٹیئرنگ",
        powerwindows: "پاور ونڈوز",
        sunroof: "سن روف",
        // Placeholders
        adTitlePlaceholder: "مثلاً ٹویوٹا کرولا 2020",
        pricePlaceholder: "مثلاً 2500000",
        mileagePlaceholder: "مثلاً 50000",
        engineCapacityPlaceholder: "مثلاً 1800",
        bodyColorPlaceholder: "مثلاً سفید",
        descriptionPlaceholder: "اپنی کار کے بارے میں لکھیں...",
        // Registration
        selectRegistrationCity: "رجسٹریشن سٹی منتخب کریں",
        petrol: "پیٹرول",
        diesel: "ڈیزل",
        cng: "سی این جی",
        lpg: "ایل پی جی",
        hybrid: "ہائبرڈ",
        electric: "الیکٹرک",
        manual: "مینول",
        automatic: "آٹومیٹک",
        cvt: "سی وی ٹی",
        sedan: "سیڈان",
        suv: "ایس یو وی",
        hatchback: "ہیچ بیک",
        coupe: "کوپے",
        convertible: "کنورٹیبل",
        wagon: "ویگن",
        van: "وین",
        pickup: "پک اپ",
        local: "لوکل",
        imported: "امپورٹڈ",
        currentImages: "موجودہ تصاویر",
        addNewImages: "نئی تصاویر شامل کریں (زیادہ سے زیادہ 10)",
        image: "تصویر",
        // Sidebar Labels
        province: "صوبہ",
        priceRange: "قیمت کی حد",
        registeredIn: "رجسٹریشن",
        trustedCars: "اعتباری کاریں",
        doors: "دروازے",
        seatingCapacity: "نشستوں کی گنجائش",
        moreChoices: "مزید انتخاب",
        showing: "دکھایا جا رہا ہے",
        filtered: "فلٹر شدہ",
        carBadge: "گاڑی",
        carsBadge: "گاڑیاں",
        loadingUsedCars: "استعمال شدہ گاڑیاں لوڈ ہو رہی ہیں...",
        unableToLoadUsedCars: "استعمال شدہ گاڑیاں لوڈ نہیں ہو سکیں",
        noUsedCarsFound: "کوئی استعمال شدہ گاڑی نہیں ملی",
        trySelectingDifferentFilters: "مختلف فلٹرز منتخب کرنے کی کوشش کریں",
        clearFilters: "فلٹرز ختم کریں",
        managed: "منیجڈ",
        premium: "پریمیئم",
        freeAdBadge: "مفت ایڈ",
        priceOnCall: "قیمت کال پر",
        viewDetails: "تفصیلات دیکھیں",
        yearLabelField: "سال:",
        transLabelField: "ٹرانس:",
        engineLabelField: "انجن:",
        mileageLabelField: "میلج:",
        from: "سے",
        to: "تک",
        go: "جائیں",
        retry: "دوبارہ کوشش کریں",
        // Provinces
        punjab: "پنجاب",
        sindh: "سندھ",
        kpk: "خیبر پختونخوا",
        balochistan: "بلوچستان",
        ajk: "آزاد کشمیر",
        "gilgit-baltistan": "گلگت بلتستان",
        islamabadcapitalterritory: "اسلام آباد وفاقی علاقہ",
        // Registration Status
        unregistered: "غیر رجسٹرڈ",
        // Trusted Cars
        autofindermanaged: "آٹو فائنڈر منیجڈ",
        premiumcars: "پریمیئم کاریں",
        verified: "تصدیق شدہ",
        // Doors & Capacity
        "2door": "2 دروازے",
        "3door": "3 دروازے",
        "4door": "4 دروازے",
        "5door": "5 دروازے",
        "2person": "2 افراد",
        "4person": "4 افراد",
        "5person": "5 افراد",
        "6person": "6 افراد",
        "7person": "7 افراد",
        "8person": "8 افراد",
        "4+person": "4 سے زائد افراد",
        "5+person": "5 سے زائد افراد",
        "6+person": "6 سے زائد افراد",
        "7+person": "7 سے زائد افراد",
        "8+person": "8 سے زائد افراد",
        // Budget Ranges
        under5Lakh: "5 لاکھ سے کم",
        "5_10Lakh": "10-5 لاکھ",
        "10_15Lakh": "10-15 لاکھ",
        // FAQ Page
        faqTitle: "اکثر پوچھے گئے سوالات",
        q1: "میں گاڑی کیسے تلاش کروں؟",
        a1: "آپ ہمارے سرچ فلٹرز استعمال کر کے گاڑیاں تلاش کر سکتے ہیں۔ اپنے لیے بہترین گاڑی تلاش کرنے کے لیے برانڈ، ماڈل، بجٹ اور دیگر ترجیحات منتخب کریں۔",
        q2: "کیا میں مختلف گاڑیوں کا موازنہ کر سکتا ہوں؟",
        a2: "جی ہاں، آپ بیک وقت 3 گاڑیوں کا موازنہ کر سکتے ہیں۔ بس کسی بھی گاڑی کے تفصیل والے صفحے پر موازنہ (compare) کے بٹن پر کلک کریں۔",
        q3: "میں ڈیلر سے کیسے رابطہ کروں؟",
        a3: "آپ گاڑی کے تفصیل والے صفحے کے ذریعے براہ راست ڈیلرز سے رابطہ کر سکتے ہیں۔ رابطہ کرنے کے لیے \"Contact Dealer\" بٹن پر کلک کریں۔",
        q4: "آپ ادائیگی کے کون سے طریقے قبول کرتے ہیں؟",
        a4: "ہم ادائیگی کے مختلف طریقے قبول کرتے ہیں جن میں نقد، بینک ٹرانسفر، اور فنانسنگ کے اختیارات شامل ہیں۔ مزید تفصیلات کے لیے ڈیلر سے رابطہ کریں۔",
        q5: "کیا آپ کار فنانسنگ کی پیشکش کرتے ہیں؟",
        a5: "جی ہاں، ہمارے بہت سے ڈیلرز فنانسنگ کے اختیارات پیش کرتے ہیں۔ براہ کرم فنانسنگ پلانز پر بات کرنے کے لیے ان سے براہ راست رابطہ کریں۔",
        // About Page
        welcomeToAutoFinder: "آٹو فائنڈر میں خوش آمدید",
        aboutMission: "ہمارا مشن",
        aboutVision: "ہمارا وژن",
        aboutValues: "ہماری اقدار",
        missionDesc: "خریداری، فروخت، کرایہ پر لینا، اور گاڑیوں کا معائنہ ہر ایک کے لیے آسان، تیز، اور زیادہ قابل اعتماد بنانا۔",
        visionDesc: "ایک معروف مکمل آٹوموٹیو پلیٹ فارم بننا جو شفاف اور پریشانی سے پاک کار کے تجربات فراہم کرتا ہے۔",
        valuesDesc: "شفافیت، وشوسنییتا، گاہکوں کی اطمینان، اور ایک آسان جگہ پر پیشہ ورانہ خدمات فراہم کرنا۔",
        // Help Page
        helpSupport: "مدد اور تعاون",
        helpDesc: "آٹو فائنڈر کے لیے مدد اور تعاون حاصل کریں۔ عام سوالات کے جوابات تلاش کریں، ہماری سپورٹ ٹیم سے رابطہ کریں، اور ہمارے پلیٹ فارم کو استعمال کرنے کا طریقہ سیکھیں۔",
        contactSupport: "سپورٹ سے رابطہ کریں",
        phoneSupport: "فون سپورٹ",
        emailSupport: "ای میل سپورٹ",
        officeAddress: "دفتر کا پتہ",
        support247: "24/7 سپورٹ لائن",
        hqAddress: "G9 مرکز، اسلام آباد، پاکستان",
        hqEmail: "autofinder786@gmail.com",
        hqPhone: "+92 334 8400943",
        hqEmailLink: "mailto:autofinder786@gmail.com",
        hqPhoneLink: "tel:+923348400943",
        hqAddressLabel: "G9 مرکز، اسلام آباد، پاکستان",
        hqEmailLabel: "autofinder786@gmail.com",
        hqPhoneLabel: "+92 334 8400943",
        // Help FAQ Qs
        hq_q1: "میں اشتہار کیسے لگاؤں؟",
        hq_a1: "اشتہار لگانے کے لیے، ہیڈر مینو میں \"Post an Ad\" پر کلک کریں، پھر \"Sell Your Car\" یا \"Sell Your Bike\" منتخب کریں۔ مفت اشتہار یا پریمیم اشتہار کے درمیان انتخاب کریں، مطلوبہ تفصیلات پُر کریں، تصاویر اپ لوڈ کریں، اور اپنا اشتہار جمع کروائیں۔ پریمیم اشتہارات کے لیے ادائیگی کی تصدیق کی ضرورت ہوتی ہے اور ہماری ایڈمن ٹیم ان کا جائزہ لے گی۔",
        hq_q2: "مفت اور پریمیم اشتہارات میں کیا فرق ہے؟",
        hq_a2: "مفت اشتہارات فوری طور پر پوسٹ ہو جاتے ہیں اور تمام صارفین کو نظر آتے ہیں۔ پریمیم اشتہارات بہتر مرئییت، نمایاں جگہ، اور تلاش کے نتائج میں ترجیح پیش کرتے ہیں۔ پریمیم اشتہارات کو لائیو ہونے سے پہلے ادائیگی کی تصدیق اور ایڈمن کی منظوری درکار ہوتی ہے۔",
        hq_q3: "میں اپنے اشتہار میں ترمیم یا اسے ختم کیسے کروں؟",
        hq_a3: "اپنے پروفائل مینو میں \"My Ads\" پر جائیں۔ آپ کو اپنے تمام پوسٹ کردہ اشتہارات نظر آئیں گے جن میں ترمیم یا حذف کرنے کے اختیارات ہوں گے۔ اپنی اشتہار کی تفصیلات میں ترمیم کرنے کے لیے \"Edit\" پر کلک کریں، یا اپنے اشتہار کو مستقل طور پر ہٹانے کے لیے \"Delete\" پر کلک کریں۔",
        hq_q4: "ڈیلر پیکجز کیا ہیں؟",
        hq_a4: "ڈیلر پیکجز سبسکرپشن پلانز ہیں جو آپ کو متعدد اشتہارات پوسٹ کرنے اور بوسٹ فیچرز استعمال کرنے کی اجازت دیتے ہیں۔ پیکجز میں اشتہارات اور بوسٹرز کی ایک خاص تعداد شامل ہوتی ہے جسے آپ پیکج کی میعاد کی مدت کے اندر استعمال کر سکتے ہیں۔ آپ مینو میں \"Dealer Packages\" سیکشن سے پیکجز خرید سکتے ہیں۔",
        hq_q5: "میں بیچنے والے سے کیسے رابطہ کروں؟",
        hq_a5: "کسی بھی کار یا بائیک کے تفصیل والے صفحے پر، آپ کو بیچنے والے کے فون نمبر اور ای میل سمیت رابطے کی معلومات مل جائیں گی۔ آپ فراہم کردہ رابطے کی تفصیلات کا استعمال کرتے ہوئے ان سے براہ راست رابطہ کر سکتے ہیں۔",
        hq_q6: "میں کاروں یا بائیکوں کو کیسے سرچ کروں؟",
        hq_a6: "ہیڈر میں سرچ بار کا استعمال کریں یا \"Used Cars\"، \"Latest Cars\"، \"Used Bikes\"، یا \"New Bikes\" سیکشنز پر جائیں۔ آپ بائیں سائڈبار پر موجود فلٹر کے اختیارات کا استعمال کرتے ہوئے کمپنی، ماڈل، قیمت کی حد، شہر، باڈی ٹائپ اور دیگر معیارات کے مطابق نتائج کو فلٹر کر سکتے ہیں۔",
        hq_q7: "ادائیگی کے کون سے طریقے قبول کیے جاتے ہیں؟",
        hq_a7: "ہم ایزی پیسہ اور جاز کیش کے ذریعے ادائیگیاں قبول کرتے ہیں۔ پیکج یا پریمیم اشتہار منتخب کرنے کے بعد، آپ سے ادائیگی کا طریقہ منتخب کرنے اور ایڈمن کی تصدیق کے لیے ادائیگی کی رسید اپ لوڈ کرنے کو کہا جائے گا۔",
        hq_q8: "میرے پریمیم اشتہار کی منظوری میں کتنا وقت لگتا ہے؟",
        hq_a8: "پریمیم اشتہارات عام طور پر ادائیگی کی تصدیق کے بعد 24 گھنٹے کے اندر لائیو ہو جاتے ہیں۔ ہماری ایڈمن ٹیم منظوری سے پہلے صداقت کو یقینی بنانے کے لیے تمام پریمیم اشتہارات اور ادائیگی کی رسیدوں کا جائزہ لیتی ہے۔",
        // Privacy Policy Page
        ppTitle: "رازداری کی پالیسی",
        lastUpdated: "آخری بار اپ ڈیٹ کیا گیا",
        ppIntro: "آٹو فائنڈر (\"ہم\"، \"ہمارا\"، یا \"ہمیں\") آپ کی رازداری کے تحفظ کے لیے پرعزم ہے۔ یہ رازداری کی پالیسی بتاتی ہے کہ جب آپ ہماری ویب سائٹ اور خدمات استعمال کرتے ہیں تو ہم آپ کی معلومات کو کیسے اکٹھا کرتے، استعمال کرتے، ظاہر کرتے اور محفوظ رکھتے ہیں۔",
        ppSection1Title: "1. معلومات جو ہم اکٹھی کرتے ہیں",
        ppSection1Text1: "ذاتی معلومات: ہم وہ معلومات اکٹھی کرتے ہیں جو آپ براہ راست ہمیں فراہم کرتے ہیں، بشمول آپ کا نام، ای میل پتہ، فون نمبر، اور پروفائل کی معلومات جب آپ اکاؤنٹ بناتے ہیں یا اشتہار لگاتے ہیں۔",
        ppSection1Text2: "اشتہار کی معلومات: جب آپ اشتہار پوسٹ کرتے ہیں، تو ہم گاڑی کے بارے میں معلومات اکٹھی کرتے ہیں بشمول کمپنی، ماڈل، سال، قیمت، تصاویر اور تفصیل۔",
        ppSection1Text3: "ادائیگی کی معلومات: پریمیم اشتہارات اور پیکجز کے لیے، ہم تصدیقی مقاصد کے لیے ادائیگی کی رسید کی معلومات جمع کرتے ہیں۔ ہم ادائیگی کی مکمل تفصیلات محفوظ نہیں کرتے ہیں۔",
        ppSection1Text4: "استعمال کا ڈیٹا: جب آپ ہماری ویب سائٹ کے ساتھ تعامل کرتے ہیں تو ہم خود بخود معلومات جمع کرتے ہیں، بشمول IP پتہ، براؤزر کی قسم، وزٹ کیے گئے صفحات، اور صفحات پر گزارا گیا وقت۔",
        ppSection2Title: "2. ہم آپ کی معلومات کا استعمال کیسے کرتے ہیں",
        ppSection2Item1: "اپنی خدمات فراہم کرنے، برقرار رکھنے اور بہتر بنانے کے لیے",
        ppSection2Item2: "آپ کے اشتہارات کی پوسٹنگ پر کارروائی کرنے اور آپ کے اکاؤنٹ کا انتظام کرنے کے لیے",
        ppSection2Item3: "ادائیگیوں کی تصدیق کرنے اور پریمیم اشتہار کی منظوریوں پر کارروائی کرنے کے لیے",
        ppSection2Item4: "آپ سے آپ کے اکاؤنٹ، اشتہارات اور ہماری خدمات کے بارے میں بات چیت کرنے کے لیے",
        ppSection2Item5: "آپ کو اپ ڈیٹس، نیوز لیٹرز، اور پروموشنل مواد بھیجنے کے لیے (آپ کی رضامندی سے)",
        ppSection2Item6: "آپ کے سوالات کا جواب دینے اور کسٹمر سپورٹ فراہم کرنے کے لیے",
        ppSection2Item7: "تکنیکی مسائل اور دھوکہ دہی کی سرگرمیوں کا پتہ لگانے، روکنے اور ان کو حل کرنے کے لیے",
        ppSection2Item8: "قانونی ذمہ داریوں کی تعمیل کرنے اور ہماری سروس کی شرائط کو نافذ کرنے کے لیے",
        ppSection3Title: "3. معلومات کا اشتراک اور انکشاف",
        ppSection3Text1: "ہم آپ کی ذاتی معلومات فروخت نہیں کرتے ہیں۔ ہم مندرجہ ذیل حالات میں آپ کی معلومات کا اشتراک کر سکتے ہیں:",
        ppSection3Item1: "عوامی اشتہاری معلومات: وہ معلومات جو آپ اپنے اشتہارات میں شامل کرتے ہیں (گاڑی کی تفصیلات، تصاویر، رابطے کی معلومات) ہمارے پلیٹ فارم کے تمام صارفین کو نظر آئیں گی۔",
        ppSection3Item2: "سروس فراہم کرنے والے: ہم تیسرے فریق کے سروس فراہم کنندگان کے ساتھ معلومات کا اشتراک کر سکتے ہیں جو ہماری ویب سائٹ چلانے اور اپنا کاروبار چلانے میں ہماری مدد کرتے ہیں۔",
        ppSection3Item3: "قانونی تقاضے: اگر قانون کے ذریعہ ضرورت ہو یا عوامی حکام کی جائز درخواستوں کے جواب میں ہم معلومات کا انکشاف کر سکتے ہیں۔",
        ppSection3Item4: "کاروباری منتقلی: انضمام، حصول، یا اثاثوں کی فروخت کی صورت میں، آپ کی معلومات حاصل کرنے والے ادارے کو منتقل کی جا سکتی ہیں۔",
        ppSection4Title: "4. ڈیٹا کی حفاظت",
        ppSection4Text: "ہم آپ کی ذاتی معلومات کو غیر مجاز رسائی، تبدیلی، انکشاف، یا تباہی سے بچانے کے لیے مناسب تکنیکی اور تنظیمی حفاظتی اقدامات نافذ کرتے ہیں۔ تاہم، انٹرنیٹ پر منتقلی یا الیکٹرانک اسٹوریج کا کوئی طریقہ 100٪ محفوظ نہیں ہے، اور ہم مکمل سیکیورٹی کی ضمانت نہیں دے سکتے۔",
        ppSection5Title: "5. آپ کے حقوق اور انتخاب",
        ppSection5Text1: "آپ کو درج ذیل حقوق حاصل ہیں:",
        ppSection5Item1: "اپنے اکاؤنٹ کی ترتیبات کے ذریعے اپنی ذاتی معلومات تک رسائی حاصل کرنا اور اسے اپ ڈیٹ کرنا",
        ppSection5Item2: "اپنا اکاؤنٹ اور اس سے وابستہ ڈیٹا حذف کرنا",
        ppSection5Item3: "اپنے پوسٹ کردہ اشتہارات میں ترمیم کریں یا انہیں ختم کریں",
        ppSection5Item4: "ہماری ای میلز سے ان سبسکرائب کر کے پروموشنل مواصلات سے باہر نکلنا",
        ppSection5Item5: "اپنے ذاتی ڈیٹا کی کاپی کی درخواست کریں",
        ppSection6Title: "6. کوکیز اور ٹریکنگ ٹیکنالوجیز",
        ppSection6Text: "ہم اپنی ویب سائٹ پر سرگرمی کو ٹریک کرنے اور کچھ معلومات کو ذخیرہ کرنے کے لیے کوکیز اور اسی طرح کی ٹریکنگ ٹیکنالوجیز استعمال کرتے ہیں۔ آپ اپنے براؤزر کو تمام کوکیز سے انکار کرنے یا کوکی بھیجے جانے کی نشاندہی کرنے کی ہدایت کر سکتے ہیں۔ تاہم، اگر آپ کوکیز قبول نہیں کرتے ہیں، تو ہو سکتا ہے آپ ہماری سروس کے کچھ حصے استعمال نہ کر سکیں۔",
        ppSection7Title: "7. تھرڈ پارٹی لنکس",
        ppSection7Text: "ہماری ویب سائٹ میں تیسرے فریق کی ویب سائٹس کے لنکس ہو سکتے ہیں۔ ہم ان بیرونی سائٹس کے رازداری کے طریقوں یا مواد کے ذمہ دار نہیں ہیں۔ ہم آپ کو مشورہ دیتے ہیں کہ آپ جس تیسرے فریق کی سائٹ پر جائیں اس کی رازداری کی پالیسیوں کا جائزہ لیں۔",
        ppSection8Title: "8. بچوں کی رازداری",
        ppSection8Text: "ہماری خدمات 18 سال سے کم عمر افراد کے لیے نہیں ہیں۔ ہم جان بوجھ کر بچوں سے ذاتی معلومات جمع نہیں کرتے ہیں۔ اگر آپ کو یقین ہے کہ ہم نے کسی بچے سے معلومات جمع کی ہیں، تو براہ کرم فوری طور پر ہم سے رابطہ کریں۔",
        ppSection9Title: "9. اس رازداری کی پالیسی میں تبدیلیاں",
        ppSection9Text: "ہم وقتاً فوقتاً اپنی پرائیویسی پالیسی کو اپ ڈیٹ کر سکتے ہیں۔ ہم اس صفحے پر نئی پرائیویسی پالیسی پوسٹ کر کے اور \"آخری بار اپ ڈیٹ کیا گیا\" تاریخ کو اپ ڈیٹ کر کے آپ کو کسی بھی تبدیلی کے بارے میں مطلع کریں گے۔ آپ کو مشورہ دیا جاتا ہے کہ کسی بھی تبدیلی کے لیے وقتاً فوقتاً اس پرائیویسی پالیسی کا جائزہ لیں۔",
        ppSection10Title: "10. ہم سے رابطہ کریں",
        ppSection10Text: "اگر آپ کے پاس اس رازداری کی پالیسی کے بارے میں کوئی سوال ہے، تو براہ کرم ہم سے رابطہ کریں:",
        // Contact Us Page Add-ons
        contactUsPageTitle: "ہم سے رابطہ کریں",
        sendMessageTitle: "پیغام بھیجیں",
        getInTouchTitle: "رابطہ کریں",
        contactAddress: "پتہ",
        contactPhone: "فون",
        contactEmail: "ای میل",
        fullName: "پورا نام",
        emailAddress: "ای میل پتہ",
        phoneOptional: "فون (اختیاری)",
        howCanWeHelp: "ہم آپ کی کیا مدد کر سکتے ہیں؟",
        yourNamePlaceholder: "آپ کا نام",
        yourEmailPlaceholder: "آپ کا ای میل",
        phonePlaceholder: "فون نمبر",
        messageSentSuccess: "آپ کا پیغام کامیابی کے ساتھ بھیج دیا گیا ہے!",
        messageSendError: "آپ کا پیغام بھیجنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
        // Blog Page Add-ons
        latestNewsHeader: "تازہ ترین خبریں",
        readLatestNews: "ہماری تازہ ترین خبریں اور اپ ڈیٹس پڑھیں",
        noBlogsAvailable: "اس وقت کوئی بلاگ پوسٹ دستیاب نہیں ہے۔",
        checkBackLater: "اپ ڈیٹس کے لیے بعد میں چیک کریں۔",
        readMoreBtn: "مزید پڑھیں →",
        adminAuthor: "ایڈمن",
        dateNotAvailable: "تاریخ دستیاب نہیں",
        blogTitleSuffixUrdu: "| آٹو فائنڈر",
        "15_20Lakh": "20-15 لاکھ",
        "20_30Lakh": "30-20 لاکھ",
        "30_50Lakh": "50-30 لاکھ",
        "50_75Lakh": "75-50 لاکھ",
        "75Lakh_1Crore": "1 کروڑ - 75 لاکھ",
        above1Crore: "1 کروڑ سے زیادہ",
        // Auto Store Page
        byCategory: "زمرہ کے لحاظ سے",
        allCategories: "تمام زمرے",
        engineParts: "انجن کے حصے",
        bodyParts: "باڈی پارٹس",
        electrical: "الیکٹریکل",
        interior: "انٹیریئر",
        exterior: "ایکسٹیریئر",
        accessories: "ایکسیسریز",
        tiresWheels: "ٹائر اور وہیل",
        brakeSystem: "بریک سسٹم",
        suspension: "سسپنشن",
        transmission: "ٹرانسمیشن",
        other: "دیگر",
        searchByPartName: "حصہ کا نام تلاش کریں...",
        itemsFound: "آئٹمز ملے"
    }
};
